(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eq-account-login"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__eqAcctBound) return;
  window.__eqAcctBound = true;
  const digits = (v) => (v || '').replace(/\D/g, '');
  const masks = {
    cpf: (d) => d.slice(0, 11).replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})\.(\d{3})(\d)/, '$1.$2.$3').replace(/\.(\d{3})(\d{1,2})$/, '.$1-$2'),
    phone: (d) => { d = d.slice(0, 11); if (d.length <= 2) return d.length ? '(' + d : ''; if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`; if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`; return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`; },
    date: (d) => { d = d.slice(0, 8); return d.length > 4 ? `${d.slice(0, 2)}/${d.slice(2, 4)}/${d.slice(4)}` : d.length > 2 ? `${d.slice(0, 2)}/${d.slice(2)}` : d; },
  };
  const validCpf = (v) => {
    const d = digits(v);
    if (d.length !== 11 || /^(\d)\1+$/.test(d)) return false;
    const calc = (n) => { let s = 0; for (let i = 0; i < n; i++) s += Number(d[i]) * (n + 1 - i); const r = (s * 10) % 11; return r === 10 ? 0 : r; };
    return calc(9) === Number(d[9]) && calc(10) === Number(d[10]);
  };
  const validDate = (v) => {
    const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(v || '');
    if (!m) return false;
    const dt = new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1]));
    const now = new Date();
    return dt.getDate() === Number(m[1]) && dt.getMonth() === Number(m[2]) - 1 && dt < now && now.getFullYear() - dt.getFullYear() < 120;
  };
  const validEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test((v || '').trim());
  const setError = (input, msg) => {
    const f = input.closest('[data-eq-field]');
    if (!f) return;
    const h = f.querySelector('[data-eq-hint]');
    f.classList.toggle('is-error', !!msg);
    if (h) { h.hidden = !msg && !h.dataset.help; h.textContent = msg || h.dataset.help || ''; }
  };
  document.addEventListener('input', (e) => {
    const el = e.target;
    const m = el.dataset && el.dataset.eqMask;
    if (m && masks[m]) el.value = masks[m](digits(el.value));
    if (el.closest && el.closest('[data-eq-field].is-error')) setError(el, '');
  });
  /* mostrar / ocultar senha */
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-eq-pwd-toggle]');
    if (!t) return;
    const input = t.parentElement.querySelector('input');
    const show = input.type === 'password';
    input.type = show ? 'text' : 'password';
    t.classList.toggle('is-on', show);
    t.setAttribute('aria-label', show ? 'Ocultar senha' : 'Mostrar senha');
  });
  /* login: e-mail → modal de senha */
  const openPwd = (form) => {
    const email = form.querySelector('[data-eq-login-email]');
    if (!validEmail(email.value)) { setError(email, email.dataset.msg || 'Informe um e-mail válido.'); email.focus(); return; }
    setError(email, '');
    form.querySelectorAll('[data-eq-login-who]').forEach((w) => (w.textContent = email.value.trim()));
    EQ.open('EqLoginPwd');
    setTimeout(() => { const p = document.getElementById('EqLoginPwdInput'); p && p.focus(); }, 120);
  };
  document.addEventListener('click', (e) => {
    const n = e.target.closest('[data-eq-login-next]');
    if (n) { e.preventDefault(); openPwd(n.closest('form')); return; }
    const r = e.target.closest('[data-eq-register-link]');
    if (r) {
      const form = r.closest('form');
      const email = form && form.querySelector('[data-eq-login-email]');
      const mkt = form && form.querySelector('[data-eq-login-mkt]');
      const u = new URL(r.href, location.origin);
      if (email && email.value) u.searchParams.set('email', email.value.trim());
      if (mkt) u.searchParams.set('mkt', mkt.checked ? '1' : '0');
      r.href = u.pathname + u.search;
    }
    const fo = e.target.closest('[data-eq-open="EqRecover"]');
    if (fo) {
      const src = document.querySelector('[data-eq-login-email]');
      const dst = document.querySelector('[data-eq-recover-email]');
      if (src && dst && !dst.value) dst.value = src.value;
      EQ.close('EqLoginPwd');
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter') return;
    const email = e.target.closest && e.target.closest('[data-eq-login-email]');
    if (email) { e.preventDefault(); openPwd(email.closest('form')); }
  });
  /* validação genérica dos formulários de conta */
  document.addEventListener('submit', (e) => {
    const f = e.target;
    if (!f.matches || !f.matches('[data-eq-validate], [data-eq-login]')) return;
    if (e.submitter && e.submitter.name === 'decline') return;
    let first = null;
    f.querySelectorAll('input, select').forEach((el) => {
      if (el.type === 'hidden' || el.type === 'checkbox' || el.disabled) return;
      const v = (el.value || '').trim();
      let msg = '';
      const req = el.required;
      if (req && !v) msg = el.dataset.msgRequired || 'Campo obrigatório.';
      else if (v && el.type === 'email' && !validEmail(v)) msg = 'Informe um e-mail válido.';
      else if (v && el.dataset.eqMask === 'cpf' && !validCpf(v)) msg = 'CPF inválido.';
      else if (v && el.dataset.eqMask === 'phone' && digits(v).length < 10) msg = 'Telefone incompleto (DDD + número).';
      else if (v && el.dataset.eqMask === 'date' && !validDate(v)) msg = 'Data inválida (dd/mm/aaaa).';
      else if (v && el.dataset.eqMin && v.length < Number(el.dataset.eqMin)) msg = `Mínimo de ${el.dataset.eqMin} caracteres.`;
      else if (el.dataset.eqMatch) { const o = f.querySelector(el.dataset.eqMatch); if (o && o.value !== el.value) msg = 'As senhas não coincidem.'; }
      setError(el, msg);
      if (msg && !first) first = el;
    });
    if (first) {
      e.preventDefault();
      if (f.matches('[data-eq-login]') && first.name === 'customer[email]') EQ.close('EqLoginPwd');
      first.focus();
    }
  });
  /* cadastro: e-mail e opt-in vindos do login */
  const prefill = () => {
    const p = new URLSearchParams(location.search);
    const em = document.querySelector('[data-eq-register-email]');
    if (em && p.get('email') && !em.value) em.value = p.get('email');
    const mk = document.querySelector('[data-eq-register-mkt]');
    if (mk && p.has('mkt')) mk.checked = p.get('mkt') === '1';
    document.querySelectorAll('[data-eq-open-on-load="true"]').forEach((m) => window.EQ && EQ.open(m.id));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prefill); else prefill();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-account-password"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__eqAcctBound) return;
  window.__eqAcctBound = true;
  const digits = (v) => (v || '').replace(/\D/g, '');
  const masks = {
    cpf: (d) => d.slice(0, 11).replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})\.(\d{3})(\d)/, '$1.$2.$3').replace(/\.(\d{3})(\d{1,2})$/, '.$1-$2'),
    phone: (d) => { d = d.slice(0, 11); if (d.length <= 2) return d.length ? '(' + d : ''; if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`; if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`; return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`; },
    date: (d) => { d = d.slice(0, 8); return d.length > 4 ? `${d.slice(0, 2)}/${d.slice(2, 4)}/${d.slice(4)}` : d.length > 2 ? `${d.slice(0, 2)}/${d.slice(2)}` : d; },
  };
  const validCpf = (v) => {
    const d = digits(v);
    if (d.length !== 11 || /^(\d)\1+$/.test(d)) return false;
    const calc = (n) => { let s = 0; for (let i = 0; i < n; i++) s += Number(d[i]) * (n + 1 - i); const r = (s * 10) % 11; return r === 10 ? 0 : r; };
    return calc(9) === Number(d[9]) && calc(10) === Number(d[10]);
  };
  const validDate = (v) => {
    const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(v || '');
    if (!m) return false;
    const dt = new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1]));
    const now = new Date();
    return dt.getDate() === Number(m[1]) && dt.getMonth() === Number(m[2]) - 1 && dt < now && now.getFullYear() - dt.getFullYear() < 120;
  };
  const validEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test((v || '').trim());
  const setError = (input, msg) => {
    const f = input.closest('[data-eq-field]');
    if (!f) return;
    const h = f.querySelector('[data-eq-hint]');
    f.classList.toggle('is-error', !!msg);
    if (h) { h.hidden = !msg && !h.dataset.help; h.textContent = msg || h.dataset.help || ''; }
  };
  document.addEventListener('input', (e) => {
    const el = e.target;
    const m = el.dataset && el.dataset.eqMask;
    if (m && masks[m]) el.value = masks[m](digits(el.value));
    if (el.closest && el.closest('[data-eq-field].is-error')) setError(el, '');
  });
  /* mostrar / ocultar senha */
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-eq-pwd-toggle]');
    if (!t) return;
    const input = t.parentElement.querySelector('input');
    const show = input.type === 'password';
    input.type = show ? 'text' : 'password';
    t.classList.toggle('is-on', show);
    t.setAttribute('aria-label', show ? 'Ocultar senha' : 'Mostrar senha');
  });
  /* login: e-mail → modal de senha */
  const openPwd = (form) => {
    const email = form.querySelector('[data-eq-login-email]');
    if (!validEmail(email.value)) { setError(email, email.dataset.msg || 'Informe um e-mail válido.'); email.focus(); return; }
    setError(email, '');
    form.querySelectorAll('[data-eq-login-who]').forEach((w) => (w.textContent = email.value.trim()));
    EQ.open('EqLoginPwd');
    setTimeout(() => { const p = document.getElementById('EqLoginPwdInput'); p && p.focus(); }, 120);
  };
  document.addEventListener('click', (e) => {
    const n = e.target.closest('[data-eq-login-next]');
    if (n) { e.preventDefault(); openPwd(n.closest('form')); return; }
    const r = e.target.closest('[data-eq-register-link]');
    if (r) {
      const form = r.closest('form');
      const email = form && form.querySelector('[data-eq-login-email]');
      const mkt = form && form.querySelector('[data-eq-login-mkt]');
      const u = new URL(r.href, location.origin);
      if (email && email.value) u.searchParams.set('email', email.value.trim());
      if (mkt) u.searchParams.set('mkt', mkt.checked ? '1' : '0');
      r.href = u.pathname + u.search;
    }
    const fo = e.target.closest('[data-eq-open="EqRecover"]');
    if (fo) {
      const src = document.querySelector('[data-eq-login-email]');
      const dst = document.querySelector('[data-eq-recover-email]');
      if (src && dst && !dst.value) dst.value = src.value;
      EQ.close('EqLoginPwd');
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter') return;
    const email = e.target.closest && e.target.closest('[data-eq-login-email]');
    if (email) { e.preventDefault(); openPwd(email.closest('form')); }
  });
  /* validação genérica dos formulários de conta */
  document.addEventListener('submit', (e) => {
    const f = e.target;
    if (!f.matches || !f.matches('[data-eq-validate], [data-eq-login]')) return;
    if (e.submitter && e.submitter.name === 'decline') return;
    let first = null;
    f.querySelectorAll('input, select').forEach((el) => {
      if (el.type === 'hidden' || el.type === 'checkbox' || el.disabled) return;
      const v = (el.value || '').trim();
      let msg = '';
      const req = el.required;
      if (req && !v) msg = el.dataset.msgRequired || 'Campo obrigatório.';
      else if (v && el.type === 'email' && !validEmail(v)) msg = 'Informe um e-mail válido.';
      else if (v && el.dataset.eqMask === 'cpf' && !validCpf(v)) msg = 'CPF inválido.';
      else if (v && el.dataset.eqMask === 'phone' && digits(v).length < 10) msg = 'Telefone incompleto (DDD + número).';
      else if (v && el.dataset.eqMask === 'date' && !validDate(v)) msg = 'Data inválida (dd/mm/aaaa).';
      else if (v && el.dataset.eqMin && v.length < Number(el.dataset.eqMin)) msg = `Mínimo de ${el.dataset.eqMin} caracteres.`;
      else if (el.dataset.eqMatch) { const o = f.querySelector(el.dataset.eqMatch); if (o && o.value !== el.value) msg = 'As senhas não coincidem.'; }
      setError(el, msg);
      if (msg && !first) first = el;
    });
    if (first) {
      e.preventDefault();
      if (f.matches('[data-eq-login]') && first.name === 'customer[email]') EQ.close('EqLoginPwd');
      first.focus();
    }
  });
  /* cadastro: e-mail e opt-in vindos do login */
  const prefill = () => {
    const p = new URLSearchParams(location.search);
    const em = document.querySelector('[data-eq-register-email]');
    if (em && p.get('email') && !em.value) em.value = p.get('email');
    const mk = document.querySelector('[data-eq-register-mkt]');
    if (mk && p.has('mkt')) mk.checked = p.get('mkt') === '1';
    document.querySelectorAll('[data-eq-open-on-load="true"]').forEach((m) => window.EQ && EQ.open(m.id));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prefill); else prefill();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-account-register"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__eqAcctBound) return;
  window.__eqAcctBound = true;
  const digits = (v) => (v || '').replace(/\D/g, '');
  const masks = {
    cpf: (d) => d.slice(0, 11).replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})\.(\d{3})(\d)/, '$1.$2.$3').replace(/\.(\d{3})(\d{1,2})$/, '.$1-$2'),
    phone: (d) => { d = d.slice(0, 11); if (d.length <= 2) return d.length ? '(' + d : ''; if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`; if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`; return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`; },
    date: (d) => { d = d.slice(0, 8); return d.length > 4 ? `${d.slice(0, 2)}/${d.slice(2, 4)}/${d.slice(4)}` : d.length > 2 ? `${d.slice(0, 2)}/${d.slice(2)}` : d; },
  };
  const validCpf = (v) => {
    const d = digits(v);
    if (d.length !== 11 || /^(\d)\1+$/.test(d)) return false;
    const calc = (n) => { let s = 0; for (let i = 0; i < n; i++) s += Number(d[i]) * (n + 1 - i); const r = (s * 10) % 11; return r === 10 ? 0 : r; };
    return calc(9) === Number(d[9]) && calc(10) === Number(d[10]);
  };
  const validDate = (v) => {
    const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(v || '');
    if (!m) return false;
    const dt = new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1]));
    const now = new Date();
    return dt.getDate() === Number(m[1]) && dt.getMonth() === Number(m[2]) - 1 && dt < now && now.getFullYear() - dt.getFullYear() < 120;
  };
  const validEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test((v || '').trim());
  const setError = (input, msg) => {
    const f = input.closest('[data-eq-field]');
    if (!f) return;
    const h = f.querySelector('[data-eq-hint]');
    f.classList.toggle('is-error', !!msg);
    if (h) { h.hidden = !msg && !h.dataset.help; h.textContent = msg || h.dataset.help || ''; }
  };
  document.addEventListener('input', (e) => {
    const el = e.target;
    const m = el.dataset && el.dataset.eqMask;
    if (m && masks[m]) el.value = masks[m](digits(el.value));
    if (el.closest && el.closest('[data-eq-field].is-error')) setError(el, '');
  });
  /* mostrar / ocultar senha */
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-eq-pwd-toggle]');
    if (!t) return;
    const input = t.parentElement.querySelector('input');
    const show = input.type === 'password';
    input.type = show ? 'text' : 'password';
    t.classList.toggle('is-on', show);
    t.setAttribute('aria-label', show ? 'Ocultar senha' : 'Mostrar senha');
  });
  /* login: e-mail → modal de senha */
  const openPwd = (form) => {
    const email = form.querySelector('[data-eq-login-email]');
    if (!validEmail(email.value)) { setError(email, email.dataset.msg || 'Informe um e-mail válido.'); email.focus(); return; }
    setError(email, '');
    form.querySelectorAll('[data-eq-login-who]').forEach((w) => (w.textContent = email.value.trim()));
    EQ.open('EqLoginPwd');
    setTimeout(() => { const p = document.getElementById('EqLoginPwdInput'); p && p.focus(); }, 120);
  };
  document.addEventListener('click', (e) => {
    const n = e.target.closest('[data-eq-login-next]');
    if (n) { e.preventDefault(); openPwd(n.closest('form')); return; }
    const r = e.target.closest('[data-eq-register-link]');
    if (r) {
      const form = r.closest('form');
      const email = form && form.querySelector('[data-eq-login-email]');
      const mkt = form && form.querySelector('[data-eq-login-mkt]');
      const u = new URL(r.href, location.origin);
      if (email && email.value) u.searchParams.set('email', email.value.trim());
      if (mkt) u.searchParams.set('mkt', mkt.checked ? '1' : '0');
      r.href = u.pathname + u.search;
    }
    const fo = e.target.closest('[data-eq-open="EqRecover"]');
    if (fo) {
      const src = document.querySelector('[data-eq-login-email]');
      const dst = document.querySelector('[data-eq-recover-email]');
      if (src && dst && !dst.value) dst.value = src.value;
      EQ.close('EqLoginPwd');
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter') return;
    const email = e.target.closest && e.target.closest('[data-eq-login-email]');
    if (email) { e.preventDefault(); openPwd(email.closest('form')); }
  });
  /* validação genérica dos formulários de conta */
  document.addEventListener('submit', (e) => {
    const f = e.target;
    if (!f.matches || !f.matches('[data-eq-validate], [data-eq-login]')) return;
    if (e.submitter && e.submitter.name === 'decline') return;
    let first = null;
    f.querySelectorAll('input, select').forEach((el) => {
      if (el.type === 'hidden' || el.type === 'checkbox' || el.disabled) return;
      const v = (el.value || '').trim();
      let msg = '';
      const req = el.required;
      if (req && !v) msg = el.dataset.msgRequired || 'Campo obrigatório.';
      else if (v && el.type === 'email' && !validEmail(v)) msg = 'Informe um e-mail válido.';
      else if (v && el.dataset.eqMask === 'cpf' && !validCpf(v)) msg = 'CPF inválido.';
      else if (v && el.dataset.eqMask === 'phone' && digits(v).length < 10) msg = 'Telefone incompleto (DDD + número).';
      else if (v && el.dataset.eqMask === 'date' && !validDate(v)) msg = 'Data inválida (dd/mm/aaaa).';
      else if (v && el.dataset.eqMin && v.length < Number(el.dataset.eqMin)) msg = `Mínimo de ${el.dataset.eqMin} caracteres.`;
      else if (el.dataset.eqMatch) { const o = f.querySelector(el.dataset.eqMatch); if (o && o.value !== el.value) msg = 'As senhas não coincidem.'; }
      setError(el, msg);
      if (msg && !first) first = el;
    });
    if (first) {
      e.preventDefault();
      if (f.matches('[data-eq-login]') && first.name === 'customer[email]') EQ.close('EqLoginPwd');
      first.focus();
    }
  });
  /* cadastro: e-mail e opt-in vindos do login */
  const prefill = () => {
    const p = new URLSearchParams(location.search);
    const em = document.querySelector('[data-eq-register-email]');
    if (em && p.get('email') && !em.value) em.value = p.get('email');
    const mk = document.querySelector('[data-eq-register-mkt]');
    if (mk && p.has('mkt')) mk.checked = p.get('mkt') === '1';
    document.querySelectorAll('[data-eq-open-on-load="true"]').forEach((m) => window.EQ && EQ.open(m.id));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prefill); else prefill();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-article-main"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__eqAmain) return;
  window.__eqAmain = true;
  const slug = (t) => String(t).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60);
  const setup = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const content = root.querySelector('[data-eq-amain-content]');
    const hs = [...content.querySelectorAll('h2')];
    /* galeria antes do último H2 (como no Figma) */
    const gal = root.querySelector('[data-eq-agal]');
    if (gal && root.dataset.galleryPos === 'before_last_h2' && hs.length > 1) content.insertBefore(gal, hs[hs.length - 1]);
    /* sumário */
    if (hs.length >= 2) {
      const used = {};
      const html = hs.map((h) => {
        if (!h.id) { let id = slug(h.textContent) || 'secao'; while (used[id] || document.getElementById(id)) id += '-2'; h.id = id; }
        used[h.id] = 1;
        return `<li><a href="#${h.id}">${h.textContent.replace(/</g, '&lt;')}</a></li>`;
      }).join('');
      root.querySelectorAll('[data-eq-amain-toc]').forEach((ol) => (ol.innerHTML = html));
      root.querySelectorAll('[data-eq-amain-tocbox], [data-eq-amain-tocside]').forEach((x) => (x.hidden = false));
      const links = [...root.querySelectorAll('[data-eq-amain-toc] a')];
      const mark = (id) => links.forEach((l) => l.classList.toggle('is-active', l.getAttribute('href') === '#' + id));
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((ents) => { const v = ents.filter((e) => e.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0]; if (v) mark(v.target.id); }, { rootMargin: '-20% 0px -70% 0px' });
        hs.forEach((h) => io.observe(h));
      }
      mark(hs[0].id);
    }
    /* galeria */
    if (gal) {
      const slides = [...gal.querySelectorAll('[data-eq-agal-slide]')];
      const thumbs = [...gal.querySelectorAll('[data-eq-agal-thumb]')];
      const win = Number(gal.dataset.window) || 5;
      const desk = matchMedia('(min-width: 990px)');
      let i = 0, start = 0;
      const paint = () => {
        slides.forEach((s, k) => (s.hidden = k !== i));
        const n = gal.querySelector('[data-eq-agal-i]');
        if (n) n.textContent = i + 1;
        thumbs.forEach((t, k) => {
          t.setAttribute('aria-current', k === i ? 'true' : 'false');
          const more = t.querySelector('.eq-agal__more');
          more.hidden = true;
          if (!desk.matches || thumbs.length <= win) { t.hidden = false; return; }
          t.hidden = k < start || k >= start + win;
          if (k === start + win - 1 && k < thumbs.length - 1) { more.hidden = false; more.textContent = '+' + (thumbs.length - 1 - k) + ' fotos'; }
          if (k === start && start > 0) { more.hidden = false; more.textContent = '+' + start; }
        });
      };
      const go = (k) => {
        i = (k + slides.length) % slides.length;
        if (i < start) start = i; else if (i >= start + win) start = i - win + 1;
        paint();
      };
      gal.addEventListener('click', (e) => {
        const g = e.target.closest('[data-eq-agal-go]');
        if (g) { go(i + Number(g.dataset.eqAgalGo)); return; }
        const t = e.target.closest('[data-eq-agal-thumb]');
        if (!t) return;
        const k = Number(t.dataset.eqAgalThumb);
        const more = t.querySelector('.eq-agal__more');
        if (more && !more.hidden) {
          if (k === start && start > 0) start = Math.max(0, start - win + 1);
          else start = Math.min(thumbs.length - win, start + win - 1);
          i = k; paint(); return;
        }
        go(k);
      });
      desk.addEventListener('change', paint);
      paint();
    }
    root.addEventListener('click', async (e) => {
      const c = e.target.closest('[data-eq-amain-copy]');
      if (!c) return;
      try { await navigator.clipboard.writeText(c.dataset.eqAmainCopy); if (window.EQ) EQ.toast(c.dataset.done); } catch (_) {}
    });
  };
  const init = () => document.querySelectorAll('[data-eq-amain]').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-blog-grid"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__eqBgrid) return;
  window.__eqBgrid = true;
  const mq = window.matchMedia('(max-width: 989px)');
  const norm = (t) => String(t || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  const fill = (t, m) => Object.keys(m).reduce((s, k) => s.split(`[${k}]`).join(m[k]), t || '');
  const setup = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const d = root.dataset;
    const cells = [...root.querySelectorAll('[data-eq-bgrid-cell]')];
    const st = { page: 1, per: Number(d.per) || 12, shown: Number(d.perM) || 6, q: '' };
    const more = root.querySelector('[data-eq-bgrid-more]');
    const render = () => {
      const words = norm(st.q).split(/\s+/).filter(Boolean);
      const list = cells.filter((c) => { const h = norm(c.firstElementChild.dataset.search); return words.every((w) => h.includes(w)); });
      const pages = Math.max(1, Math.ceil(list.length / st.per));
      st.page = Math.min(Math.max(1, st.page), pages);
      const from = mq.matches ? 0 : (st.page - 1) * st.per;
      const to = mq.matches ? st.shown : from + st.per;
      cells.forEach((c) => (c.hidden = true));
      list.forEach((c, i) => (c.hidden = !(i >= from && i < to)));
      root.querySelector('[data-eq-bgrid-empty]').hidden = list.length > 0;
      root.querySelector('[data-eq-bgrid-of]').textContent = fill(d.showing, { n: list.length });
      const foot = root.querySelector('[data-eq-bgrid-foot]');
      foot.style.display = list.length ? '' : 'none';
      const pager = root.querySelector('[data-eq-bgrid-pager]');
      pager.style.visibility = pages > 1 ? '' : 'hidden';
      pager.querySelector('[data-eq-bgrid-page="prev"]').disabled = st.page <= 1;
      pager.querySelector('[data-eq-bgrid-page="next"]').disabled = st.page >= pages;
      const arr = [];
      for (let i = 1; i <= pages; i++) if (i === 1 || i === pages || Math.abs(i - st.page) <= 1 || pages <= 5) arr.push(i); else if (arr[arr.length - 1] !== '…') arr.push('…');
      pager.querySelector('[data-eq-bgrid-nums]').innerHTML = arr.map((n) => (n === '…' ? '<span class="eq-pager__gap">…</span>' : `<button type="button" class="eq-pager__num" data-eq-bgrid-page="${n}"${n === st.page ? ' aria-current="page"' : ''} aria-label="Página ${n}">${n}</button>`)).join('');
      if (more) more.hidden = !(mq.matches && st.shown < list.length);
    };
    root.addEventListener('click', (e) => {
      const p = e.target.closest('[data-eq-bgrid-page]');
      if (!p) return;
      const v = p.dataset.eqBgridPage;
      st.page = v === 'prev' ? st.page - 1 : v === 'next' ? st.page + 1 : Number(v);
      render();
      root.scrollIntoView({ block: 'start' });
    });
    root.querySelector('[data-eq-bgrid-per]').addEventListener('change', (e) => { st.per = Number(e.target.value) || 12; st.page = 1; render(); });
    document.addEventListener('eq:cont:search', (e) => { const x = e.detail || {}; if (x.scope && x.scope !== 'posts') return; st.q = x.q || ''; st.page = 1; st.shown = Number(d.perM) || 6; render(); });
    mq.addEventListener('change', render);
    if (more && 'IntersectionObserver' in window) {
      new IntersectionObserver((ents) => { if (ents.some((x) => x.isIntersecting) && !more.hidden) setTimeout(() => { st.shown += Number(d.perM) || 6; render(); }, 250); }, { rootMargin: '200px' }).observe(more);
    }
    render();
  };
  const init = () => document.querySelectorAll('[data-eq-bgrid]').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-calculator"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__eqCalcV2) return;
  window.__eqCalcV2 = true;
  const num = (v) => { const n = parseFloat(String(v == null ? '' : v).replace(',', '.')); return isFinite(n) ? n : 0; };
  const fmtL = (ml) => (Math.round(ml / 100) / 10).toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
  const norm = (t) => String(t || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
  const fill = (tpl, map) => Object.keys(map).reduce((t, k) => t.split(`[${k}]`).join(map[k]), tpl || '');
  const isMobile = () => window.matchMedia('(max-width: 989px)').matches;
  const ready = (root) => {
    const f = root.querySelector('[data-eq-calc-form]');
    const w = num(f.querySelector('[data-eq-calc-weight]').value);
    const h = f.querySelector('[data-eq-calc-height]');
    let ok = w >= 20 && w <= 350;
    if (h.required && !h.value.trim()) ok = false;
    f.querySelectorAll('[data-eq-calc-group]').forEach((s) => { if (!s.value) ok = false; });
    f.querySelector('[data-eq-calc-submit]').disabled = !ok;
    return ok;
  };
  const pick = (f, g) => {
    const s = f.querySelector(`[data-eq-calc-group="${g}"]`);
    const o = s && s.selectedOptions[0];
    return o && o.value ? { min: num(o.dataset.min), max: num(o.dataset.max), elec: o.dataset.elec === '1' } : null;
  };
  const compute = (root) => {
    const d = root.dataset;
    const f = root.querySelector('[data-eq-calc-form]');
    const w = num(f.querySelector('[data-eq-calc-weight]').value);
    let lo, hi, elec = false;
    if (d.type === 'hydration') {
      /* ml/dia = peso × ml/kg (faixa etária) + ml do treino (frequência) × multiplicador (intensidade) + ml da transpiração */
      const age = pick(f, 'idade') || { min: 30, max: 35 };
      const act = pick(f, 'atividade') || { min: 0, max: 0 };
      const ints = pick(f, 'intensidade') || { min: 1, max: 1 };
      const sweat = pick(f, 'transpiracao') || { min: 0, max: 0 };
      lo = w * age.min + act.min * (ints.min || 1) + sweat.min;
      hi = w * age.max + act.max * (ints.max || ints.min || 1) + sweat.max;
      /* eletrólitos (não mexe na faixa de água): transpiração "Alto" (opção marcada) OU treino > 60 min em dia quente */
      const ex = (g) => { const s = f.querySelector(`[data-eq-calc-extra="${g}"]`); const o = s && s.selectedOptions[0]; return o && o.value ? o.dataset.v || '' : ''; };
      const minutes = num(ex('treino'));
      const hot = ['sim', 's', 'yes', '1', 'true'].includes(norm(ex('calor')));
      elec = !!sweat.elec || (minutes > 60 && hot);
    } else {
      /* g/dia = peso × (g/kg da frequência + ajustes de faixa etária, objetivo e GLP-1), limitado ao fator mín./máx. */
      const base = pick(f, 'atividade') || { min: 0.8, max: 1 };
      let fmin = base.min, fmax = base.max;
      ['idade', 'objetivo', 'glp1'].forEach((g) => { const o = pick(f, g); if (o) { fmin += o.min; fmax += o.max; } });
      const floor = num(d.floor) || 0, ceil = num(d.ceiling) || 99;
      fmin = Math.min(Math.max(fmin, floor), ceil);
      fmax = Math.min(Math.max(fmax, fmin), ceil);
      lo = Math.round(w * fmin);
      hi = Math.round(w * fmax);
    }
    return { lo, hi, elec };
  };
  const render = (root, r) => {
    const d = root.dataset;
    const H = d.type === 'hydration';
    root.classList.add('is-done');
    const minTxt = H ? fmtL(r.lo) : String(r.lo);
    const maxTxt = H ? fmtL(r.hi) : String(r.hi);
    root.querySelector('[data-eq-calc-value]').textContent = fill(d.rangeText || '[min] a [max]', { min: minTxt, max: maxTxt }) + (H ? ' L' : ' g');
    const glass = num(d.glass) || 250;
    const cmin = Math.round(r.lo / glass), cmax = Math.max(cmin, Math.round(r.hi / glass));
    root.querySelector('[data-eq-calc-expl]').textContent = fill(d.resultText, { copos_min: cmin, copos_max: cmax, min: minTxt, max: maxTxt });
    if (H) {
      root.querySelectorAll('.eq-calc__cup').forEach((c, i) => {
        c.classList.toggle('is-full', i < cmin);
        c.classList.toggle('is-part', i >= cmin && i < cmax);
        c.classList.toggle('is-off', i >= cmax);
      });
      const e = root.querySelector('[data-eq-calc-elec]');
      if (e) e.hidden = !r.elec;
      const note = root.querySelector('[data-eq-calc-note]');
      if (note) note.hidden = !!r.elec;
    } else {
      const meals = [...root.querySelectorAll('[data-eq-calc-meal]')];
      const tot = meals.reduce((a, m) => a + num(m.dataset.pct), 0) || 1;
      const maxShare = Math.max(...meals.map((m) => num(m.dataset.pct))) || 1;
      let accLo = 0, accHi = 0;
      meals.forEach((m, i) => {
        const share = num(m.dataset.pct) / tot;
        let a = Math.round(r.lo * share), b = Math.round(r.hi * share);
        if (i === meals.length - 1) { a = r.lo - accLo; b = r.hi - accHi; }
        accLo += a; accHi += b;
        m.querySelector('[data-eq-calc-meal-value]').textContent = `${a} a ${b} g`;
        m.querySelector('[data-eq-calc-meal-bar]').style.width = `${Math.round((num(m.dataset.pct) / maxShare) * 83)}%`;
      });
    }
    const box = root.querySelector('[data-eq-calc-products]');
    if (box) {
      box.hidden = false;
      const sub = box.querySelector('[data-eq-calc-psub]');
      if (sub) sub.textContent = fill(d.productsSub, { min: H ? fmtL(r.lo) : r.lo });
      box.querySelectorAll('[data-eq-calc-cover]').forEach((c) => {
        const per = num(c.dataset.per);
        const pct = r.lo > 0 ? Math.round((per / r.lo) * 100) : 0;
        c.querySelector('[data-eq-calc-cover-bar]').style.width = `${Math.min(100, pct)}%`;
        c.querySelector('[data-eq-calc-cover-pct]').textContent = fill(d.coverPct, { pct });
      });
    }
  };
  const showMobileResult = (root, on) => {
    root.classList.toggle('is-mview', on);
    const mh = root.querySelector('[data-eq-calc-mhead]');
    if (mh) mh.hidden = !on;
  };
  const run = (root, scroll) => {
    if (!ready(root)) return;
    const r = compute(root);
    const err = root.querySelector('[data-eq-calc-err]');
    if (!(r.hi > 0)) { if (err) err.hidden = false; return; }
    if (err) err.hidden = true;
    render(root, r);
    showMobileResult(root, true);
    if (scroll && isMobile()) {
      root.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      const b = root.querySelector('[data-eq-calc-back]');
      if (b) b.focus({ preventScroll: true });
    }
  };
  document.addEventListener('input', (e) => { const root = e.target.closest && e.target.closest('[data-eq-calc]'); if (root) ready(root); });
  document.addEventListener('change', (e) => { const root = e.target.closest && e.target.closest('[data-eq-calc]'); if (root) ready(root); });
  document.addEventListener('submit', (e) => {
    const f = e.target.closest && e.target.closest('[data-eq-calc-form]');
    if (!f) return;
    e.preventDefault();
    run(f.closest('[data-eq-calc]'), true);
  });
  document.addEventListener('click', (e) => {
    const b = e.target.closest && e.target.closest('[data-eq-calc-back]');
    if (!b) return;
    const root = b.closest('[data-eq-calc]');
    showMobileResult(root, false);
    root.scrollIntoView({ block: 'start' });
    const w = root.querySelector('[data-eq-calc-weight]');
    if (w) w.focus({ preventScroll: true });
  });
  const init = () => {
    const p = new URLSearchParams(location.search);
    document.querySelectorAll('[data-eq-calc]').forEach((root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      const f = root.querySelector('[data-eq-calc-form]');
      if (!f) return;
      if (!p.has('peso')) { ready(root); return; }
      f.querySelector('[data-eq-calc-weight]').value = p.get('peso');
      if (p.get('altura')) f.querySelector('[data-eq-calc-height]').value = p.get('altura');
      f.querySelectorAll('[data-eq-calc-group], [data-eq-calc-extra]').forEach((s) => {
        const want = norm(p.get(s.dataset.eqCalcGroup || s.dataset.eqCalcExtra));
        if (!want) return;
        const o = [...s.options].find((x) => x.value && norm(x.value) === want);
        if (o) { s.value = o.value; s.classList.add('has-value'); }
      });
      run(root, false);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-cart-page"] && !Shopify.designMode) return;
  try {
    
(() => {
  /* barra fixa no mobile: aparece quando o resumo não está visível */
  const bind = () => {
    const page = document.querySelector('[data-eq-cart-page]');
    if (!page) return;
    const sticky = page.querySelector('[data-eq-cp-sticky]');
    const sum = page.querySelector('[data-eq-cp-sum]');
    if (!sticky || !sum || sum.dataset.io) return;
    sum.dataset.io = '1';
    const io = new IntersectionObserver(([e]) => {
      const on = !e.isIntersecting && e.boundingClientRect.top > 0;
      sticky.classList.toggle('is-on', on);
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      sticky.querySelectorAll('button').forEach((b) => (b.tabIndex = on ? 0 : -1));
    });
    io.observe(sum);
  };
  const back = (e) => {
    const a = e.target.closest('[data-eq-cp-back]');
    if (!a) return;
    if (document.referrer && new URL(document.referrer).origin === location.origin && history.length > 1) { e.preventDefault(); history.back(); }
  };
  document.addEventListener('click', back);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
  document.addEventListener('eq:cart:updated', () => setTimeout(bind, 30));
  document.addEventListener('shopify:section:load', bind);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-cart-reco"] && !Shopify.designMode) return;
  try {
    
(() => {
  const load = (sec) => {
    if (!sec || !sec.dataset.url || sec.dataset.loaded) return;
    sec.dataset.loaded = '1';
    fetch(sec.dataset.url).then((r) => r.text()).then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-eq-reco-track]');
      const cur = sec.querySelector('[data-eq-reco-track]');
      if (fresh && cur && fresh.children.length) { cur.innerHTML = fresh.innerHTML; sec.hidden = false; }
    }).catch(() => {});
  };
  const boot = () => document.querySelectorAll('[data-eq-cart-reco]').forEach(load);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-collection-grid"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.EQ_CGRID) return;
  window.EQ_CGRID = 1;
  const mqD = window.matchMedia('(min-width: 990px)');
  const esc = (t) => String(t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const money = (c) => (window.EQ ? EQ.money(c) : c / 100);

  /* ---------- modo cliente ---------- */
  class ClientGrid {
    constructor(root) {
      this.root = root;
      this.items = [...root.querySelectorAll('.eq-cgrid__item')];
      this.groups = {};
      root.querySelectorAll('[data-eq-fgroup]').forEach((g) => (this.groups[g.dataset.eqFgroup] = g.dataset.label || g.dataset.eqFgroup));
      this.state = { f: {}, min: null, max: null, sort: 'relevance', page: 1, shown: 0 };
      const prices = this.items.map((i) => Number(i.dataset.p));
      this.pmin = Math.floor(Math.min(...prices, 0) / 100);
      this.pmax = Math.ceil(Math.max(...prices, 0) / 100);
      this.per = Number(mqD.matches ? root.dataset.perD : root.dataset.perM) || 9;
      this.readUrl();
      this.setupPrice();
      const per = root.querySelector('[data-eq-per]');
      if (per) {
        if (![...per.options].some((o) => Number(o.value) === this.per)) per.insertAdjacentHTML('afterbegin', `<option value="${this.per}">${this.per}</option>`);
        per.value = String(this.per);
      }
      const sort = root.querySelector('[data-eq-sort]');
      if (sort) sort.value = this.state.sort;
      this.apply(false);
    }
    readUrl() {
      const q = new URLSearchParams(location.search);
      Object.keys(this.groups).forEach((g) => { const v = q.get(g); if (v) this.state.f[g] = v.split('~').filter(Boolean); });
      if (q.get('preco')) { const [a, b] = q.get('preco').split('-').map(Number); this.state.min = a || null; this.state.max = b || null; }
      if (q.get('ordem')) this.state.sort = q.get('ordem');
      if (q.get('pagina')) this.state.page = Math.max(1, Number(q.get('pagina')));
    }
    writeUrl() {
      const u = new URL(location.href);
      Object.keys(this.groups).forEach((g) => { const v = this.state.f[g]; if (v && v.length) u.searchParams.set(g, v.join('~')); else u.searchParams.delete(g); });
      if (this.state.min !== null || this.state.max !== null) u.searchParams.set('preco', (this.state.min || '') + '-' + (this.state.max || '')); else u.searchParams.delete('preco');
      if (this.state.sort !== 'relevance') u.searchParams.set('ordem', this.state.sort); else u.searchParams.delete('ordem');
      if (this.state.page > 1 && mqD.matches) u.searchParams.set('pagina', this.state.page); else u.searchParams.delete('pagina');
      history.replaceState(history.state, '', u.toString());
    }
    setupPrice() {
      this.root.querySelectorAll('[data-eq-price-range]').forEach((w) => {
        w.querySelectorAll('input[type=range]').forEach((r) => { r.min = this.pmin; r.max = this.pmax; });
        const [a, b] = w.querySelectorAll('input[type=range]');
        a.value = this.state.min ?? this.pmin;
        b.value = this.state.max ?? this.pmax;
        this.paintPrice(w);
      });
    }
    paintPrice(w) {
      const [a, b] = w.querySelectorAll('input[type=range]');
      const lo = Math.min(Number(a.value), Number(b.value));
      const hi = Math.max(Number(a.value), Number(b.value));
      const span = Math.max(1, this.pmax - this.pmin);
      w.style.setProperty('--lo', ((lo - this.pmin) * 100) / span + '%');
      w.style.setProperty('--hi', ((hi - this.pmin) * 100) / span + '%');
      const fa = w.querySelector('[data-eq-price-min]');
      const fb = w.querySelector('[data-eq-price-max]');
      if (fa && document.activeElement !== fa) fa.value = lo;
      if (fb && document.activeElement !== fb) fb.value = hi;
    }
    matches(it, skip) {
      for (const g of Object.keys(this.state.f)) {
        if (g === skip) continue;
        const vals = this.state.f[g];
        if (!vals || !vals.length) continue;
        const have = it.dataset['f' + g[0].toUpperCase() + g.slice(1)] || '';
        if (!vals.some((v) => have.includes('|' + v + '|'))) return false;
      }
      if (skip !== '__price') {
        const p = Number(it.dataset.p) / 100;
        if (this.state.min !== null && p < this.state.min) return false;
        if (this.state.max !== null && p > this.state.max) return false;
      }
      return true;
    }
    toggle(g, v, on) {
      const list = (this.state.f[g] = this.state.f[g] || []);
      const i = list.indexOf(v);
      if (on === undefined) on = i < 0;
      if (on && i < 0) list.push(v);
      if (!on && i >= 0) list.splice(i, 1);
      this.state.page = 1;
      this.apply();
    }
    set(g, vals) { this.state.f[g] = vals.slice(); this.state.page = 1; this.apply(); }
    clear() { this.state.f = {}; this.state.min = this.state.max = null; this.state.page = 1; this.setupPrice(); this.apply(); }
    apply(write = true) {
      const st = this.state;
      const res = this.items.filter((it) => this.matches(it));
      const key = st.sort;
      const sorted = res.slice().sort((x, y) => {
        if (key === 'price-asc') return x.dataset.p - y.dataset.p;
        if (key === 'price-desc') return y.dataset.p - x.dataset.p;
        if (key === 'title-asc') return x.dataset.t.localeCompare(y.dataset.t, 'pt-BR');
        if (key === 'created-desc') return y.dataset.c - x.dataset.c;
        return x.dataset.i - y.dataset.i;
      });
      const list = this.root.querySelector('[data-eq-items]');
      sorted.forEach((it) => list.appendChild(it));
      this.items.filter((it) => !res.includes(it)).forEach((it) => list.appendChild(it));
      const pages = Math.max(1, Math.ceil(sorted.length / this.per));
      if (st.page > pages) st.page = pages;
      let from = 0, to = sorted.length;
      if (mqD.matches) { from = (st.page - 1) * this.per; to = from + this.per; }
      else { st.shown = Math.max(st.shown || this.per, this.per); to = st.shown; }
      this.items.forEach((it) => (it.hidden = true));
      sorted.slice(from, to).forEach((it) => (it.hidden = false));
      const more = this.root.querySelector('[data-eq-more]');
      if (more) more.hidden = mqD.matches || to >= sorted.length;
      this.root.querySelectorAll('[data-eq-total]').forEach((el) => (el.textContent = sorted.length));
      const empty = this.root.querySelector('[data-eq-empty]');
      if (empty) empty.hidden = sorted.length > 0;
      this.paintPages(pages);
      this.paintOptions();
      this.paintApplied();
      document.dispatchEvent(new CustomEvent('eq:filter:state', { detail: st.f }));
      if (write) this.writeUrl();
    }
    paintPages(pages) {
      const nav = this.root.querySelector('[data-eq-pages]');
      if (!nav) return;
      const p = this.state.page;
      if (pages <= 1) { nav.innerHTML = ''; return; }
      const L = nav.dataset;
      let h = `<button type="button" class="eq-cgrid__pg-nav" data-eq-page="${p - 1}"${p <= 1 ? ' disabled' : ''}>${L.prevIcon || ''}${esc(L.prev || 'Anterior')}</button>`;
      for (let i = 1; i <= pages; i++) {
        if (pages > 7 && i > 2 && i < pages - 1 && Math.abs(i - p) > 1) { if (!h.endsWith('…</span>')) h += '<span class="eq-cgrid__pg">…</span>'; continue; }
        h += `<button type="button" class="eq-cgrid__pg${i === p ? ' is-active' : ''}" data-eq-page="${i}"${i === p ? ' aria-current="page"' : ''}>${i}</button>`;
      }
      h += `<button type="button" class="eq-cgrid__pg-nav" data-eq-page="${p + 1}"${p >= pages ? ' disabled' : ''}>${esc(L.next || 'Próximo')}${L.nextIcon || ''}</button>`;
      nav.innerHTML = h;
    }
    paintOptions() {
      const counts = {};
      Object.keys(this.groups).forEach((g) => {
        const base = this.items.filter((it) => this.matches(it, g));
        const key = 'f' + g[0].toUpperCase() + g.slice(1);
        counts[g] = (v) => base.filter((it) => (it.dataset[key] || '').includes('|' + v + '|')).length;
      });
      this.root.querySelectorAll('[data-eq-fopt]').forEach((o) => {
        const g = o.dataset.group;
        const v = o.dataset.value;
        const on = (this.state.f[g] || []).includes(v);
        const n = counts[g] ? counts[g](v) : 0;
        const input = o.matches('input') ? o : o.querySelector('input');
        if (input) input.checked = on;
        o.setAttribute('aria-pressed', on ? 'true' : 'false');
        o.classList.toggle('is-active', on);
        const lab = o.closest('[data-eq-fopt-wrap]') || o;
        lab.classList.toggle('is-disabled', n === 0 && !on);
        if (input) input.disabled = n === 0 && !on;
        else o.disabled = n === 0 && !on;
        const c = lab.querySelector('[data-eq-fopt-count]');
        if (c) c.textContent = '(' + n + ')';
      });
      this.root.querySelectorAll('[data-eq-price-range]').forEach((w) => this.paintPrice(w));
    }
    paintApplied() {
      const chips = [];
      Object.keys(this.state.f).forEach((g) => (this.state.f[g] || []).forEach((v) => {
        const opt = this.root.querySelector(`[data-eq-fopt][data-group="${g}"][data-value="${CSS.escape(v)}"]`);
        const label = (opt && opt.dataset.label) || v;
        chips.push(`<button type="button" class="eq-tag-x" data-eq-fremove data-group="${esc(g)}" data-value="${esc(v)}">${esc(label)}<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg></button>`);
      }));
      if (this.state.min !== null || this.state.max !== null) chips.push(`<button type="button" class="eq-tag-x" data-eq-fremove data-group="__price">${esc(money((this.state.min ?? this.pmin) * 100))} – ${esc(money((this.state.max ?? this.pmax) * 100))}<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg></button>`);
      this.root.querySelectorAll('[data-eq-applied]').forEach((el) => (el.innerHTML = chips.join('')));
      this.root.querySelectorAll('[data-eq-applied-wrap]').forEach((el) => (el.hidden = chips.length === 0));
      this.root.querySelectorAll('[data-eq-fcount]').forEach((el) => { el.textContent = chips.length; el.toggleAttribute('data-zero', chips.length === 0); });
      this.root.querySelectorAll('[data-eq-fcount-wrap]').forEach((el) => (el.hidden = chips.length === 0));
    }
    onClick(e) {
      const rm = e.target.closest('[data-eq-fremove]');
      if (rm) {
        if (rm.dataset.group === '__price') { this.state.min = this.state.max = null; this.setupPrice(); this.state.page = 1; this.apply(); }
        else this.toggle(rm.dataset.group, rm.dataset.value, false);
        return true;
      }
      if (e.target.closest('[data-eq-fclear]')) { this.clear(); return true; }
      const pill = e.target.closest('button[data-eq-fopt]');
      if (pill) { this.toggle(pill.dataset.group, pill.dataset.value); return true; }
      const pg = e.target.closest('[data-eq-page]');
      if (pg && !pg.disabled) { this.state.page = Number(pg.dataset.eqPage); this.apply(); this.root.scrollIntoView({ behavior: 'smooth', block: 'start' }); return true; }
      if (e.target.closest('[data-eq-more]')) { this.state.shown = (this.state.shown || this.per) + this.per; this.apply(false); return true; }
      return false;
    }
    onChange(e) {
      const t = e.target;
      if (t.matches('input[data-eq-fopt]')) { this.toggle(t.dataset.group, t.dataset.value, t.checked); return; }
      if (t.matches('[data-eq-sort]')) { this.state.sort = t.value; this.state.page = 1; this.apply(); return; }
      if (t.matches('[data-eq-per]')) { this.per = Number(t.value); this.state.page = 1; this.state.shown = this.per; this.apply(); return; }
      if (t.matches('[data-eq-price-min], [data-eq-price-max]')) {
        const w = t.closest('[data-eq-price-range]');
        const [a, b] = w.querySelectorAll('input[type=range]');
        if (t.matches('[data-eq-price-min]')) a.value = t.value; else b.value = t.value;
        this.commitPrice(w);
      }
      if (t.matches('[data-eq-price-range] input[type=range]')) this.commitPrice(t.closest('[data-eq-price-range]'));
    }
    onInput(e) {
      const t = e.target;
      if (t.matches('[data-eq-price-range] input[type=range]')) this.paintPrice(t.closest('[data-eq-price-range]'));
    }
    commitPrice(w) {
      const [a, b] = w.querySelectorAll('input[type=range]');
      const lo = Math.min(Number(a.value), Number(b.value));
      const hi = Math.max(Number(a.value), Number(b.value));
      this.state.min = lo > this.pmin ? lo : null;
      this.state.max = hi < this.pmax ? hi : null;
      this.root.querySelectorAll('[data-eq-price-range]').forEach((o) => { if (o !== w) { const [x, y] = o.querySelectorAll('input[type=range]'); x.value = lo; y.value = hi; } });
      this.state.page = 1;
      this.apply();
    }
  }

  /* ---------- modo nativo (Search & Discovery + Section Rendering) ---------- */
  class NativeGrid {
    constructor(root) { this.root = root; this.paint(); }
    paint() {
      const first = this.root.querySelector('[data-eq-applied]');
      const n = first ? first.querySelectorAll('.eq-tag-x').length : 0;
      this.root.querySelectorAll('[data-eq-fcount]').forEach((el) => { el.textContent = n; el.toggleAttribute('data-zero', n === 0); });
      this.root.querySelectorAll('[data-eq-fcount-wrap]').forEach((el) => (el.hidden = n === 0));
      this.root.querySelectorAll('[data-eq-applied-wrap]').forEach((el) => (el.hidden = n === 0));
    }
    params() {
      const p = new URLSearchParams();
      const seen = new Set();
      this.root.querySelectorAll('[data-eq-native] input').forEach((i) => {
        if ((i.type === 'checkbox' && !i.checked) || !i.name || i.value === '') return;
        const k = i.name + '=' + i.value;
        if (seen.has(k)) return;
        seen.add(k);
        p.append(i.name, i.value);
      });
      const sort = this.root.querySelector('[data-eq-sort]');
      if (sort) p.set('sort_by', sort.value);
      return p;
    }
    async load(url, append) {
      this.root.classList.add('is-loading');
      const u = new URL(url, location.href);
      u.searchParams.set('section_id', this.root.dataset.sectionId);
      try {
        const html = await fetch(u.toString()).then((r) => r.text());
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-eq-cgrid-root]');
        const cur = this.root.querySelector('[data-eq-cgrid-root]');
        if (!fresh || !cur) return;
        if (append) {
          const list = cur.querySelector('[data-eq-items]');
          fresh.querySelectorAll('[data-eq-items] > li').forEach((li) => list.appendChild(li));
          const more = cur.querySelector('[data-eq-more-link]');
          const fm = fresh.querySelector('[data-eq-more-link]');
          if (more) { if (fm) more.href = fm.href; else more.remove(); }
        } else {
          const sheetOpen = this.root.querySelector('.eq-sheet.is-open');
          cur.innerHTML = fresh.innerHTML;
          if (sheetOpen && window.EQ) EQ.open(this.root.dataset.sheet);
          u.searchParams.delete('section_id');
          history.replaceState(history.state, '', u.toString());
        }
        this.paint();
        if (window.EQ && EQ.favs) document.dispatchEvent(new CustomEvent('eq:fav:changed', { detail: EQ.favs.get() }));
      } finally {
        this.root.classList.remove('is-loading');
      }
    }
    onClick(e) {
      const a = e.target.closest('[data-eq-native-link], [data-eq-page-link], [data-eq-more-link]');
      if (a) { e.preventDefault(); this.load(a.href, a.matches('[data-eq-more-link]')); return true; }
      if (e.target.closest('[data-eq-fclear]')) { const u = new URL(location.pathname, location.href); const s = this.root.querySelector('[data-eq-sort]'); if (s) u.searchParams.set('sort_by', s.value); this.load(u.toString()); return true; }
      return false;
    }
    onChange(e) {
      const t = e.target;
      if (t.closest('[data-eq-native]') && t.name) {
        this.root.querySelectorAll('[data-eq-native] input').forEach((o) => {
          if (o === t || o.name !== t.name) return;
          if (t.type === 'checkbox' && o.value === t.value) o.checked = t.checked;
          if (t.type !== 'checkbox') o.value = t.value;
        });
      }
      if (t.closest('[data-eq-native]') || t.matches('[data-eq-sort]')) {
        clearTimeout(this.t);
        this.t = setTimeout(() => this.load(location.pathname + '?' + this.params().toString()), 250);
      }
    }
    onInput() {}
  }

  const grids = new Map();
  const get = (el) => {
    const root = el.closest && el.closest('[data-eq-cgrid]');
    if (!root) return null;
    if (!grids.has(root)) grids.set(root, root.dataset.mode === 'native' ? new NativeGrid(root) : new ClientGrid(root));
    return grids.get(root);
  };
  const boot = () => document.querySelectorAll('[data-eq-cgrid]').forEach((r) => get(r));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', (e) => { grids.clear(); boot(); });

  document.addEventListener('click', (e) => {
    const tg = e.target.closest('[data-eq-cgrid-toggle]');
    if (tg) {
      const root = tg.closest('[data-eq-cgrid]');
      const on = root.classList.toggle('is-collapsed');
      tg.setAttribute('aria-expanded', on ? 'false' : 'true');
      return;
    }
    const g = get(e.target);
    if (g && g.onClick(e)) e.preventDefault();
  });
  document.addEventListener('change', (e) => { const g = get(e.target); if (g) g.onChange(e); });
  document.addEventListener('input', (e) => { const g = get(e.target); if (g) g.onInput(e); });
  document.addEventListener('eq:filter:set', (e) => {
    document.querySelectorAll('[data-eq-cgrid]').forEach((r) => { const g = get(r); if (g && g.set) g.set(e.detail.group, e.detail.values); });
  });
  mqD.addEventListener('change', () => grids.forEach((g) => { if (g.apply) { g.per = Number(mqD.matches ? g.root.dataset.perD : g.root.dataset.perM) || 9; g.state.shown = 0; g.apply(false); } }));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-collection-head"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.EQ_CHEAD) return;
  window.EQ_CHEAD = 1;
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-eq-sub]');
    if (!b) return;
    const bar = b.closest('[data-eq-subfilters]');
    document.dispatchEvent(new CustomEvent('eq:filter:set', { detail: { group: bar.dataset.group, values: b.dataset.eqSub ? [b.dataset.eqSub] : [] } }));
  });
  document.addEventListener('eq:filter:state', (e) => {
    document.querySelectorAll('[data-eq-subfilters]').forEach((bar) => {
      const vals = (e.detail && e.detail[bar.dataset.group]) || [];
      bar.querySelectorAll('[data-eq-sub]').forEach((b) => b.classList.toggle('is-active', b.dataset.eqSub ? vals.length === 1 && vals[0] === b.dataset.eqSub : vals.length === 0));
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-cont-faq"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__eqCfaq) return;
  window.__eqCfaq = true;
  document.addEventListener('click', (e) => {
    const chip = e.target.closest && e.target.closest('[data-eq-cfaq-chip]');
    if (!chip) return;
    const root = chip.closest('[data-eq-cfaq]');
    const tag = chip.dataset.eqCfaqChip;
    root.querySelectorAll('[data-eq-cfaq-chip]').forEach((c) => c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'));
    const list = root.querySelector('.eq-cfaq__list');
    list.classList.toggle('is-filtered', !!tag);
    list.querySelectorAll('.eq-cfaq__item').forEach((it) => {
      const on = !tag || (it.dataset.tags || '').includes('|' + tag + '|');
      it.classList.toggle('is-hidden', !on);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-cont-head"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__eqContSearch) return;
  window.__eqContSearch = true;
  const emit = (form) => {
    const q = (form.querySelector('input[type=search]').value || '').trim();
    document.dispatchEvent(new CustomEvent('eq:cont:search', { detail: { q, scope: form.dataset.scope || '' } }));
  };
  document.addEventListener('submit', (e) => {
    const f = e.target.closest && e.target.closest('[data-eq-cont-search]');
    if (!f || f.dataset.mode !== 'filter') return;
    e.preventDefault();
    emit(f);
  });
  let t;
  document.addEventListener('input', (e) => {
    const f = e.target.closest && e.target.closest('[data-eq-cont-search][data-mode="filter"]');
    if (!f) return;
    clearTimeout(t);
    t = setTimeout(() => emit(f), 300);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-faq"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__eqFaqBound) return;
  window.__eqFaqBound = true;
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-eq-faq-tab]');
    if (!t) return;
    const root = t.closest('[data-eq-faq]');
    root.querySelectorAll('[data-eq-faq-tab]').forEach((b) => { const on = b === t; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); });
    const k = t.dataset.eqFaqTab;
    root.querySelectorAll('.eq-faq__item').forEach((d) => { d.hidden = !!k && d.dataset.cat !== k; });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-fav-list"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    const chips = root.querySelectorAll('[data-eq-favl-filter]');
    const items = root.querySelectorAll('[data-eq-favl-tags]');
    const count = root.querySelector('[data-eq-favl-count]');
    const none = root.querySelector('[data-eq-favl-none]');
    chips.forEach((chip) =>
      chip.addEventListener('click', () => {
        const f = chip.dataset.eqFavlFilter;
        chips.forEach((c) => c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'));
        let n = 0;
        items.forEach((it) => {
          const on = it.dataset.eqFavlTags.split(' ').includes(f);
          it.hidden = !on;
          if (on) n++;
        });
        if (count) count.textContent = n;
        if (none) none.hidden = n > 0;
      })
    );
  };
  const boot = () => document.querySelectorAll('.eq-favl').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-footer"]) return;
  try {
    
(() => {
  /* acordeões só no mobile: no desktop as colunas ficam sempre abertas */
  const cols = document.querySelectorAll('[data-eq-footer-col]');
  if (!cols.length) return;
  const mq = window.matchMedia('(min-width: 990px)');
  const sync = () => cols.forEach((d) => (mq.matches ? d.setAttribute('open', '') : d.removeAttribute('open')));
  sync();
  if (mq.addEventListener) mq.addEventListener('change', sync);
  cols.forEach((d) => d.querySelector('summary').addEventListener('click', (e) => { if (mq.matches) e.preventDefault(); }));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-header"]) return;
  try {
    
(() => {
  const header = document.querySelector('[data-eq-header]');
  if (!header || header.dataset.ready) return;
  header.dataset.ready = '1';
  const section = header.closest('.shopify-section') || header.parentElement;
  const desktop = window.matchMedia('(min-width: 990px)');
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)');

  /* ---- mega menus: hover (ponteiro fino), foco (teclado) e toque (1.º toque abre) ---- */
  const panels = {};
  header.querySelectorAll('[data-eq-mega]').forEach((p) => (panels[p.dataset.eqMega] = p));
  let timer;
  const closeAll = (except) => {
    header.querySelectorAll('[data-eq-mega-item].is-open').forEach((it) => {
      if (it.dataset.eqMegaItem === except) return;
      it.classList.remove('is-open');
      const a = it.querySelector('[aria-expanded]');
      if (a) a.setAttribute('aria-expanded', 'false');
    });
    Object.entries(panels).forEach(([id, p]) => id !== except && p.classList.remove('is-open'));
  };
  const open = (item) => {
    clearTimeout(timer);
    const id = item.dataset.eqMegaItem;
    closeAll(id);
    item.classList.add('is-open');
    const a = item.querySelector('[aria-expanded]');
    if (a) a.setAttribute('aria-expanded', 'true');
    if (panels[id]) panels[id].classList.add('is-open');
  };
  const scheduleClose = () => {
    clearTimeout(timer);
    timer = setTimeout(() => closeAll(), 140);
  };
  header.querySelectorAll('[data-eq-mega-item]').forEach((item) => {
    item.addEventListener('mouseenter', () => fine.matches && open(item));
    item.addEventListener('mouseleave', () => fine.matches && scheduleClose());
    item.addEventListener('focusin', () => open(item));
    const link = item.querySelector('.eq-header__nav-link');
    link.addEventListener('click', (e) => {
      if (!fine.matches && !item.classList.contains('is-open')) {
        e.preventDefault();
        open(item);
      }
    });
  });
  Object.values(panels).forEach((p) => {
    p.addEventListener('mouseenter', () => clearTimeout(timer));
    p.addEventListener('mouseleave', () => fine.matches && scheduleClose());
    p.addEventListener('focusout', (e) => {
      if (!p.contains(e.relatedTarget) && !(e.relatedTarget && e.relatedTarget.closest('[data-eq-mega-item]'))) scheduleClose();
    });
  });
  header.addEventListener('focusout', (e) => {
    if (!header.contains(e.relatedTarget)) closeAll();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const openItem = header.querySelector('[data-eq-mega-item].is-open');
    if (openItem) {
      closeAll();
      const a = openItem.querySelector('.eq-header__nav-link');
      if (a) a.focus();
    }
  });
  document.addEventListener('click', (e) => {
    if (!header.contains(e.target)) closeAll();
  });
  /* editor: selecionar o bloco abre o painel */
  document.addEventListener('shopify:block:select', (e) => {
    const p = e.target.closest && e.target.closest('[data-eq-mega]');
    if (!p) return;
    const item = header.querySelector(`.eq-header__navbar [data-eq-mega-item="${p.dataset.eqMega}"]`);
    if (item) open(item);
  });
  document.addEventListener('shopify:block:deselect', () => closeAll());

  /* ---- versão reduzida fixa (desktop) e header grudado (mobile) ---- */
  const input = header.querySelector('.eq-header__search input[data-placeholder-full]');
  let ph = null;
  const setTopbarH = () => {
    const tb = header.querySelector('.eq-header__topbar');
    section.style.setProperty('--eq-topbar-h', (tb ? tb.offsetHeight : 0) + 'px');
  };
  const onScroll = () => {
    if (!desktop.matches || header.dataset.sticky !== 'condensed') {
      if (header.classList.contains('is-condensed')) uncondense();
      return;
    }
    const limit = ph ? ph.offsetHeight + 40 : header.offsetHeight + 40;
    const want = window.scrollY > limit;
    if (want === header.classList.contains('is-condensed')) return;
    if (want) {
      ph = document.createElement('div');
      ph.style.height = header.offsetHeight + 'px';
      ph.setAttribute('aria-hidden', 'true');
      header.before(ph);
      header.classList.add('is-condensed');
      if (input) input.placeholder = input.dataset.placeholderCondensed;
      closeAll();
    } else uncondense();
  };
  const uncondense = () => {
    header.classList.remove('is-condensed');
    if (ph) ph.remove();
    ph = null;
    if (input) input.placeholder = input.dataset.placeholderFull;
  };
  const setHeaderH = () => document.documentElement.style.setProperty('--eq-header-h', header.getBoundingClientRect().bottom + 'px');
  if (header.dataset.stickyMobile === 'true') section.classList.add('is-sticky-m');
  setTopbarH();
  window.addEventListener('scroll', () => { onScroll(); setHeaderH(); }, { passive: true });
  window.addEventListener('resize', () => { setTopbarH(); onScroll(); setHeaderH(); });
  if (desktop.addEventListener) desktop.addEventListener('change', onScroll);
  setHeaderH();
  onScroll();

  /* ---- busca mobile ---- */
  const ms = header.querySelector('[data-eq-msearch]');
  header.querySelectorAll('[data-eq-toggle-search]').forEach((b) =>
    b.addEventListener('click', () => {
      if (!ms) return;
      ms.hidden = !ms.hidden;
      b.setAttribute('aria-expanded', ms.hidden ? 'false' : 'true');
      if (!ms.hidden) ms.querySelector('input[name="q"]').focus();
    })
  );

  /* ---- painéis do menu mobile (principal ↔ Minha conta) ---- */
  document.addEventListener('click', (e) => {
    const go = e.target.closest('[data-eq-mpanel-go]');
    if (!go) return;
    const drawer = document.getElementById('EqMenuDrawer');
    let target = null;
    drawer.querySelectorAll('[data-eq-mpanel]').forEach((p) => {
      p.hidden = p.dataset.eqMpanel !== go.dataset.eqMpanelGo;
      if (!p.hidden) target = p;
    });
    const f = target && target.querySelector('button, a');
    if (f) f.focus({ preventScroll: true });
  });
  /* ao fechar a gaveta volta ao painel principal */
  const drawer = document.getElementById('EqMenuDrawer');
  if (drawer) {
    new MutationObserver(() => {
      if (!drawer.classList.contains('is-open')) drawer.querySelectorAll('[data-eq-mpanel]').forEach((p) => (p.hidden = p.dataset.eqMpanel !== 'main'));
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-home-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('eq-home-hero')) return;
    const mq = matchMedia('(min-width: 990px)');
    class EqHomeHero extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = '1';
        this.all = [...this.querySelectorAll('[data-hh-slide]')];
        this.dotsAll = [...this.querySelectorAll('[data-hh-dot]')];
        this.i = 0;
        this.querySelector('[data-hh-prev]')?.addEventListener('click', () => this.go(this.i - 1, true));
        this.querySelector('[data-hh-next]')?.addEventListener('click', () => this.go(this.i + 1, true));
        this.dotsAll.forEach((d) => d.addEventListener('click', () => {
          const idx = this.list.indexOf(this.all[Number(d.dataset.hhDot)]);
          if (idx >= 0) this.go(idx, true);
        }));
        let x0 = null;
        let y0 = null;
        this.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
        this.addEventListener('touchend', (e) => {
          if (x0 === null) return;
          const dx = e.changedTouches[0].clientX - x0;
          const dy = e.changedTouches[0].clientY - y0;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) this.go(this.i + (dx < 0 ? 1 : -1), true);
          x0 = null;
        });
        this.onMq = () => this.filter();
        mq.addEventListener('change', this.onMq);
        this.filter();
        const sec = Number(this.dataset.autoplay || 0);
        const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (sec > 0 && !reduce && !(window.Shopify && Shopify.designMode)) {
          this.timer = setInterval(() => { if (!document.hidden && !this.paused) this.go(this.i + 1); }, sec * 1000);
          this.addEventListener('pointerenter', () => (this.paused = true));
          this.addEventListener('pointerleave', () => (this.paused = false));
          this.addEventListener('focusin', () => (this.paused = true));
        }
        document.addEventListener('shopify:block:select', (e) => {
          const idx = this.list.findIndex((s) => s.contains(e.target));
          if (idx >= 0) this.go(idx);
        });
        /* fotos dos slides 2+ (template data-hh-media): entram 1s depois do load, ou antes, ao interagir com o banner */
        const all = () => this.media();
        if (document.readyState === 'complete') setTimeout(all, 1000);
        else window.addEventListener('load', () => setTimeout(all, 1000), { once: true });
        ['pointerenter', 'touchstart', 'focusin'].forEach((ev) => this.addEventListener(ev, all, { once: true, passive: true }));
      }
      media(slide) {
        const ts = slide ? slide.querySelectorAll('template[data-hh-media]') : this.querySelectorAll('template[data-hh-media]');
        ts.forEach((t) => t.replaceWith(document.importNode(t.content, true)));
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        mq.removeEventListener('change', this.onMq);
      }
      filter() {
        const d = mq.matches;
        const ok = (el) => el.dataset.vis === 'all' || el.dataset.vis === (d ? 'desktop' : 'mobile');
        this.list = this.all.filter(ok);
        this.dotsAll.forEach((dot) => (dot.hidden = !ok(dot)));
        const ctrl = this.querySelector('.eq-hhero__controls');
        if (ctrl) ctrl.hidden = this.list.length < 2;
        const cur = this.all.find((s) => s.classList.contains('is-active'));
        this.go(Math.max(0, this.list.indexOf(cur)));
      }
      go(n) {
        if (!this.list || !this.list.length) return;
        this.i = (n + this.list.length) % this.list.length;
        const active = this.list[this.i];
        this.media(active);
        this.all.forEach((s) => {
          const on = s === active;
          s.classList.toggle('is-active', on);
          s.toggleAttribute('inert', !on);
          s.setAttribute('aria-hidden', on ? 'false' : 'true');
        });
        const k = this.all.indexOf(active);
        this.dotsAll.forEach((dot) => {
          const on = Number(dot.dataset.hhDot) === k;
          dot.classList.toggle('is-active', on);
          dot.setAttribute('aria-current', on ? 'true' : 'false');
        });
      }
    }
    customElements.define('eq-home-hero', EqHomeHero);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-inst-contact"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.EQ_INST_FORM) return;
  window.EQ_INST_FORM = true;
  const fmt = {
    cpf: (d) => d.slice(0, 11).replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d{1,2})$/, '$1-$2'),
    cnpj: (d) => d.slice(0, 14).replace(/^(\d{2})(\d)/, '$1.$2').replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3').replace(/\.(\d{3})(\d)/, '.$1/$2').replace(/(\d{4})(\d)/, '$1-$2'),
    phone: (d) => { d = d.slice(0, 11); return d.length > 10 ? d.replace(/^(\d{2})(\d{5})(\d{0,4}).*/, '($1) $2-$3') : d.replace(/^(\d{2})(\d{4})(\d{0,4}).*/, '($1) $2-$3').replace(/^(\d{2})(\d{0,4})$/, '($1) $2'); },
    cep: (d) => d.slice(0, 8).replace(/^(\d{5})(\d)/, '$1-$2'),
  };
  document.addEventListener('input', (e) => {
    const el = e.target.closest('[data-eq-mask]');
    if (!el) return;
    const d = el.value.replace(/\D/g, '');
    const f = fmt[el.dataset.eqMask];
    if (f) el.value = d ? f(d).replace(/[-./() ]+$/, '') : '';
  });
  window.EQ_INST_VALIDATE = (scope) => {
    let ok = true; let first = null;
    scope.querySelectorAll('input, select, textarea').forEach((el) => {
      if (el.type === 'hidden' || el.disabled || el.closest('[hidden]')) return;
      const box = el.closest('.eq-ifield');
      let valid = el.checkValidity();
      if (valid && el.dataset.eqMask === 'cpf' && el.value) valid = el.value.replace(/\D/g, '').length === 11;
      if (valid && el.dataset.eqMask === 'cnpj' && el.value) valid = el.value.replace(/\D/g, '').length === 14;
      if (valid && el.dataset.eqMask === 'cep' && el.value) valid = el.value.replace(/\D/g, '').length === 8;
      if (box) { box.classList.toggle('is-error', !valid); const er = box.querySelector('.eq-ifield__err'); if (er) er.hidden = valid; }
      el.setAttribute('aria-invalid', valid ? 'false' : 'true');
      if (!valid) { ok = false; first = first || el; }
    });
    if (first) first.focus();
    return ok;
  };
  document.addEventListener('change', (e) => {
    const s = e.target.closest('.eq-ifield .eq-select');
    if (s) s.classList.toggle('has-value', !!s.value);
    const box = e.target.closest('.eq-ifield.is-error');
    if (box && e.target.checkValidity()) { box.classList.remove('is-error'); const er = box.querySelector('.eq-ifield__err'); if (er) er.hidden = true; }
  });
  document.addEventListener('submit', (e) => {
    const f = e.target.closest('form[data-eq-validate]');
    if (!f) return;
    if (!window.EQ_INST_VALIDATE(f)) { e.preventDefault(); return; }
    const b = f.querySelector('[type=submit]');
    if (b) { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); }
  });
})();

(() => {
  const init = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const dataEl = root.querySelector('[data-eq-ict-data]');
    if (!dataEl) return;
    let data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    const clean = (arr) => (arr || []).map((x) => x.trim()).filter(Boolean);
    const lists = { a: clean(data.a), b: clean(data.b) };
    const routes = {};
    clean(data.routes).forEach((line) => { const [subj, ...rest] = line.split('|'); routes[subj.trim()] = rest.join('|').trim(); });
    const faqs = Object.entries(data.faq || {}).map(([h, v]) => ({ h, ...v })).sort((x, y) => x.o - y.o);
    const sel = root.querySelector('[data-eq-ict-subject]');
    const pf = root.querySelector('[data-eq-ict-profile-field]');
    const rf = root.querySelector('[data-eq-ict-route-field]');
    const sugg = root.querySelector('[data-eq-ict-sugg]');
    const sl = root.querySelector('[data-eq-ict-sugg-list]');
    const route = root.querySelector('[data-eq-ict-route]');
    const rt = root.querySelector('[data-eq-ict-route-title]');
    const sub = root.querySelector('[data-eq-ict-submit]');
    const legal = root.querySelector('[data-eq-ict-legal]');
    const msgLabel = root.querySelector('#ct-body') && root.querySelector('label[for="ct-body"]');
    const msgA = msgLabel ? msgLabel.innerHTML : '';
    const msgB = root.dataset.msgRoute;
    const faqUrl = root.dataset.faqUrl;
    const fill = (key) => {
      if (!sel) return;
      const cur = sel.value;
      sel.innerHTML = '<option value=""></option>' + lists[key].map((o) => `<option${o === cur ? ' selected' : ''}>${o.replace(/</g, '&lt;')}</option>`).join('');
      sel.classList.toggle('has-value', !!sel.value);
      update();
    };
    const update = () => {
      const v = sel ? sel.value : '';
      const r = routes[v];
      const isRoute = !!r;
      root.classList.toggle('is-route', isRoute);
      root.querySelectorAll('[data-eq-ict-routeonly]').forEach((el) => {
        el.hidden = !isRoute;
        el.querySelectorAll('input, textarea, select').forEach((i) => (i.disabled = !isRoute));
      });
      if (rf) { rf.disabled = !isRoute; rf.value = r || ''; }
      if (route) { route.hidden = !isRoute; if (rt && r) rt.textContent = r; }
      if (sub) sub.textContent = isRoute && sub.dataset.b ? sub.dataset.b : sub.dataset.a;
      if (legal) legal.hidden = isRoute;
      if (msgLabel && root.dataset.msgRoute) msgLabel.innerHTML = isRoute ? root.dataset.msgRoute + '<em>*</em>' : msgA;
      const list = v ? faqs.filter((f) => (f.s || []).includes(v)).slice(0, 3) : [];
      if (sugg && sl) {
        sugg.hidden = isRoute || !list.length;
        sl.innerHTML = list.map((f) => `<li><a href="${faqUrl}#${encodeURIComponent(f.h)}">${f.q.replace(/</g, '&lt;')}<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a></li>`).join('');
      }
      try { sessionStorage.setItem('eq-ict-route', isRoute ? '1' : ''); } catch (e) {}
    };
    if (sel) sel.addEventListener('change', update);
    root.querySelectorAll('[data-eq-ict-profile]').forEach((c) => c.addEventListener('click', () => {
      root.querySelectorAll('[data-eq-ict-profile]').forEach((x) => { const on = x === c; x.classList.toggle('is-active', on); x.setAttribute('aria-checked', on ? 'true' : 'false'); });
      if (pf) pf.value = c.textContent.trim();
      fill(c.dataset.eqIctProfile);
    }));
    if (sel) fill('a');
    const ok = root.querySelector('[data-eq-ict-okattach]');
    try { if (ok && sessionStorage.getItem('eq-ict-route')) ok.hidden = false; } catch (e) {}
  };
  document.querySelectorAll('[data-eq-ict]').forEach(init);
  document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('[data-eq-ict]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-inst-faq"] && !Shopify.designMode) return;
  try {
    
(() => {
  const norm = (t) => (t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  const init = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const list = root.querySelector('[data-eq-ifaq-list]');
    if (!list) return;
    const items = [...list.querySelectorAll('.eq-fq')];
    items.sort((a, b) => Number(a.dataset.order || 999) - Number(b.dataset.order || 999)).forEach((el) => list.appendChild(el));
    const q = root.querySelector('[data-eq-ifaq-q]');
    const chips = [...root.querySelectorAll('[data-eq-ifaq-chip]')];
    const empty = root.querySelector('[data-eq-ifaq-empty]');
    const firstMode = root.dataset.first;
    let chip = (chips.find((c) => c.classList.contains('is-active')) || {}).dataset?.eqIfaqChip || '*';
    const apply = () => {
      const term = norm(q && q.value.trim());
      let shown = 0;
      items.forEach((el) => {
        let ok;
        if (term) ok = norm(el.textContent).includes(term);
        else if (chip === '*') ok = firstMode === 'top' ? el.dataset.top === '1' : true;
        else ok = (el.dataset.tags || '').split('|').includes(chip);
        el.hidden = !ok;
        if (ok) shown++;
      });
      if (firstMode === 'top' && !term && chip === '*' && shown === 0) { items.forEach((el) => (el.hidden = false)); shown = items.length; }
      if (empty) empty.hidden = shown > 0;
    };
    chips.forEach((c) => c.addEventListener('click', () => {
      chip = c.dataset.eqIfaqChip;
      chips.forEach((x) => { const on = x === c; x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      if (q) q.value = '';
      apply();
    }));
    if (q) q.addEventListener('input', () => {
      if (q.value.trim()) chips.forEach((x) => { x.classList.remove('is-active'); x.setAttribute('aria-pressed', 'false'); });
      else { const c = chips.find((x) => x.dataset.eqIfaqChip === chip) || chips[0]; if (c) { c.classList.add('is-active'); c.setAttribute('aria-pressed', 'true'); } }
      apply();
    });
    apply();
    if (root.dataset.openFirst === 'true') { const f = items.find((el) => !el.hidden); if (f) f.open = true; }
    const hash = decodeURIComponent(location.hash.slice(1));
    if (hash) { const t = root.querySelector('[id="' + CSS.escape(hash) + '"]'); if (t && t.classList.contains('eq-fq')) { t.hidden = false; t.open = true; setTimeout(() => t.scrollIntoView({ block: 'center' }), 50); } }
    const ld = root.parentElement && root.parentElement.querySelector('script[data-eq-ifaq-ld]');
    if (ld) {
      ld.textContent = JSON.stringify({ '@context': 'https://schema.org', '@type': 'FAQPage', mainEntity: items.map((el) => ({ '@type': 'Question', name: el.querySelector('summary').textContent.trim(), acceptedAnswer: { '@type': 'Answer', text: el.querySelector('.eq-fq__a').textContent.trim() } })) });
    }
  };
  document.querySelectorAll('[data-eq-ifaq]').forEach(init);
  document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('[data-eq-ifaq]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-inst-form-prescriber"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.EQ_INST_FORM) return;
  window.EQ_INST_FORM = true;
  const fmt = {
    cpf: (d) => d.slice(0, 11).replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d{1,2})$/, '$1-$2'),
    cnpj: (d) => d.slice(0, 14).replace(/^(\d{2})(\d)/, '$1.$2').replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3').replace(/\.(\d{3})(\d)/, '.$1/$2').replace(/(\d{4})(\d)/, '$1-$2'),
    phone: (d) => { d = d.slice(0, 11); return d.length > 10 ? d.replace(/^(\d{2})(\d{5})(\d{0,4}).*/, '($1) $2-$3') : d.replace(/^(\d{2})(\d{4})(\d{0,4}).*/, '($1) $2-$3').replace(/^(\d{2})(\d{0,4})$/, '($1) $2'); },
    cep: (d) => d.slice(0, 8).replace(/^(\d{5})(\d)/, '$1-$2'),
  };
  document.addEventListener('input', (e) => {
    const el = e.target.closest('[data-eq-mask]');
    if (!el) return;
    const d = el.value.replace(/\D/g, '');
    const f = fmt[el.dataset.eqMask];
    if (f) el.value = d ? f(d).replace(/[-./() ]+$/, '') : '';
  });
  window.EQ_INST_VALIDATE = (scope) => {
    let ok = true; let first = null;
    scope.querySelectorAll('input, select, textarea').forEach((el) => {
      if (el.type === 'hidden' || el.disabled || el.closest('[hidden]')) return;
      const box = el.closest('.eq-ifield');
      let valid = el.checkValidity();
      if (valid && el.dataset.eqMask === 'cpf' && el.value) valid = el.value.replace(/\D/g, '').length === 11;
      if (valid && el.dataset.eqMask === 'cnpj' && el.value) valid = el.value.replace(/\D/g, '').length === 14;
      if (valid && el.dataset.eqMask === 'cep' && el.value) valid = el.value.replace(/\D/g, '').length === 8;
      if (box) { box.classList.toggle('is-error', !valid); const er = box.querySelector('.eq-ifield__err'); if (er) er.hidden = valid; }
      el.setAttribute('aria-invalid', valid ? 'false' : 'true');
      if (!valid) { ok = false; first = first || el; }
    });
    if (first) first.focus();
    return ok;
  };
  document.addEventListener('change', (e) => {
    const s = e.target.closest('.eq-ifield .eq-select');
    if (s) s.classList.toggle('has-value', !!s.value);
    const box = e.target.closest('.eq-ifield.is-error');
    if (box && e.target.checkValidity()) { box.classList.remove('is-error'); const er = box.querySelector('.eq-ifield__err'); if (er) er.hidden = true; }
  });
  document.addEventListener('submit', (e) => {
    const f = e.target.closest('form[data-eq-validate]');
    if (!f) return;
    if (!window.EQ_INST_VALIDATE(f)) { e.preventDefault(); return; }
    const b = f.querySelector('[type=submit]');
    if (b) { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); }
  });
})();

(() => {
  const init = (root) => {
    const form = root.querySelector('.eq-pform');
    if (!form || form.dataset.ready) return;
    form.dataset.ready = '1';
    const steps = [...form.querySelectorAll('[data-eq-pstep]')];
    const live = form.querySelector('[data-eq-pstep-live]');
    const show = (i) => {
      steps.forEach((st, k) => (st.hidden = k !== i));
      const t = steps[i].querySelector('.eq-pstep__title');
      if (live && t) live.textContent = t.textContent + ' · ' + (i + 1) + '/' + steps.length;
      const card = form.closest('.eq-iform__card');
      if (card && card.getBoundingClientRect().top < 0) card.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      const f = steps[i].querySelector('input:not([type=hidden]), select');
      if (f) f.focus({ preventScroll: true });
    };
    form.addEventListener('click', (e) => {
      const next = e.target.closest('[data-eq-pnext]');
      const back = e.target.closest('[data-eq-pback]');
      if (!next && !back) return;
      e.preventDefault();
      const i = steps.findIndex((st) => !st.hidden);
      if (next) { if (window.EQ_INST_VALIDATE(steps[i])) show(Math.min(steps.length - 1, i + 1)); }
      else show(Math.max(0, i - 1));
    });
    form.addEventListener('submit', (e) => {
      const bad = steps.findIndex((st) => { const h = st.hidden; st.hidden = false; const ok = window.EQ_INST_VALIDATE(st); st.hidden = h; return !ok; });
      if (bad >= 0) { e.preventDefault(); e.stopImmediatePropagation(); show(bad); window.EQ_INST_VALIDATE(steps[bad]); }
    }, true);
    const cep = form.querySelector('[data-eq-cep]');
    if (cep) cep.addEventListener('input', async () => {
      const d = cep.value.replace(/\D/g, '');
      if (d.length !== 8 || cep.dataset.last === d) return;
      cep.dataset.last = d;
      try {
        const r = await fetch('https://viacep.com.br/ws/' + d + '/json/');
        const j = await r.json();
        if (j.erro) return;
        const set = (id, v) => { const el = form.querySelector('#' + id); if (el && v && !el.value) { el.value = v; el.dispatchEvent(new Event('change', { bubbles: true })); } };
        set('ps-addr', j.logradouro); set('ps-dist', j.bairro); set('ps-city', j.localidade); set('ps-uf', j.uf);
        const uf = form.querySelector('#ps-uf');
        if (uf && j.uf) { const o = [...uf.options].find((x) => x.value === j.uf || x.value.startsWith(j.uf)); if (o) { uf.value = o.value; uf.classList.add('has-value'); } }
      } catch (err) {}
    });
  };
  document.querySelectorAll('.eq-iform3').forEach(init);
  document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('.eq-iform3').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-inst-form-reseller"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.EQ_INST_FORM) return;
  window.EQ_INST_FORM = true;
  const fmt = {
    cpf: (d) => d.slice(0, 11).replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d{1,2})$/, '$1-$2'),
    cnpj: (d) => d.slice(0, 14).replace(/^(\d{2})(\d)/, '$1.$2').replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3').replace(/\.(\d{3})(\d)/, '.$1/$2').replace(/(\d{4})(\d)/, '$1-$2'),
    phone: (d) => { d = d.slice(0, 11); return d.length > 10 ? d.replace(/^(\d{2})(\d{5})(\d{0,4}).*/, '($1) $2-$3') : d.replace(/^(\d{2})(\d{4})(\d{0,4}).*/, '($1) $2-$3').replace(/^(\d{2})(\d{0,4})$/, '($1) $2'); },
    cep: (d) => d.slice(0, 8).replace(/^(\d{5})(\d)/, '$1-$2'),
  };
  document.addEventListener('input', (e) => {
    const el = e.target.closest('[data-eq-mask]');
    if (!el) return;
    const d = el.value.replace(/\D/g, '');
    const f = fmt[el.dataset.eqMask];
    if (f) el.value = d ? f(d).replace(/[-./() ]+$/, '') : '';
  });
  window.EQ_INST_VALIDATE = (scope) => {
    let ok = true; let first = null;
    scope.querySelectorAll('input, select, textarea').forEach((el) => {
      if (el.type === 'hidden' || el.disabled || el.closest('[hidden]')) return;
      const box = el.closest('.eq-ifield');
      let valid = el.checkValidity();
      if (valid && el.dataset.eqMask === 'cpf' && el.value) valid = el.value.replace(/\D/g, '').length === 11;
      if (valid && el.dataset.eqMask === 'cnpj' && el.value) valid = el.value.replace(/\D/g, '').length === 14;
      if (valid && el.dataset.eqMask === 'cep' && el.value) valid = el.value.replace(/\D/g, '').length === 8;
      if (box) { box.classList.toggle('is-error', !valid); const er = box.querySelector('.eq-ifield__err'); if (er) er.hidden = valid; }
      el.setAttribute('aria-invalid', valid ? 'false' : 'true');
      if (!valid) { ok = false; first = first || el; }
    });
    if (first) first.focus();
    return ok;
  };
  document.addEventListener('change', (e) => {
    const s = e.target.closest('.eq-ifield .eq-select');
    if (s) s.classList.toggle('has-value', !!s.value);
    const box = e.target.closest('.eq-ifield.is-error');
    if (box && e.target.checkValidity()) { box.classList.remove('is-error'); const er = box.querySelector('.eq-ifield__err'); if (er) er.hidden = true; }
  });
  document.addEventListener('submit', (e) => {
    const f = e.target.closest('form[data-eq-validate]');
    if (!f) return;
    if (!window.EQ_INST_VALIDATE(f)) { e.preventDefault(); return; }
    const b = f.querySelector('[type=submit]');
    if (b) { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-inst-quiz"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    let products = [];
    try { products = JSON.parse(root.querySelector('[data-eq-q-data]').textContent); } catch (e) {}
    const cards = [...root.querySelectorAll('[data-eq-q]')];
    const stage = root.querySelector('[data-eq-q-stage]');
    const result = root.querySelector('[data-eq-q-result]');
    const grid = root.querySelector('[data-eq-q-grid]');
    const items = new Map([...grid.querySelectorAll('[data-pid]')].map((el) => [Number(el.dataset.pid), el]));
    const answersEl = root.querySelector('[data-eq-q-answers]');
    const none = root.querySelector('[data-eq-q-none]');
    const count = Number(root.dataset.count || 4);
    const relax = root.dataset.relax === 'true';
    const onePerFamily = root.dataset.onePerFamily === 'true';
    let picked = [];
    const norm = (t) => String(t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim();
    const show = (i) => {
      cards.forEach((c, k) => { c.hidden = k !== i; c.classList.toggle('is-in', k === i); });
      const first = cards[i] && cards[i].querySelector('input');
      if (first) first.focus({ preventScroll: true });
    };
    cards.forEach((card, i) => {
      card.addEventListener('change', (e) => {
        const inp = e.target;
        if (inp.type === 'checkbox' && inp.checked) {
          const boxes = [...card.querySelectorAll('input')];
          if (inp.dataset.exclusive === 'true') boxes.forEach((b) => { if (b !== inp) b.checked = false; });
          else boxes.forEach((b) => { if (b.dataset.exclusive === 'true') b.checked = false; });
        }
        card.querySelector('.eq-quiz2__err').hidden = true;
      });
      card.addEventListener('submit', (e) => e.preventDefault());
      card.addEventListener('click', (e) => {
        if (e.target.closest('[data-eq-q-back]')) { e.preventDefault(); show(Math.max(0, i - 1)); return; }
        if (!e.target.closest('[data-eq-q-next]')) return;
        e.preventDefault();
        if (!card.querySelector('input:checked')) { card.querySelector('.eq-quiz2__err').hidden = false; return; }
        if (i < cards.length - 1) show(i + 1); else finish();
      });
    });
    // valores: separados por vírgula (ou por | quando o valor tem vírgula); '=Valor' = obrigatório e '!Valor' = exclui, sempre (também ao completar)
    const parseVals = (raw) => {
      const parts = String(raw || '').split(String(raw || '').includes('|') ? '|' : ',').map((x) => x.trim()).filter(Boolean);
      return {
        values: parts.filter((v) => !/^[!=]/.test(v)).map(norm).filter(Boolean),
        must: parts.filter((v) => v[0] === '=').map((v) => norm(v.slice(1))).filter(Boolean),
        not: parts.filter((v) => v[0] === '!').map((v) => norm(v.slice(1))).filter(Boolean),
      };
    };
    const collect = () => cards.flatMap((card) => [...card.querySelectorAll('input:checked')].map((inp) => ({
      inp, field: card.dataset.field, mode: card.dataset.mode, label: inp.dataset.label,
      ...parseVals(inp.dataset.values), weight: Number(inp.dataset.weight || 0),
    })));
    const has = (p, field, v) => { const raw = p.f[field]; const arr = Array.isArray(raw) ? raw : raw ? [raw] : []; return arr.map(norm).includes(v); };
    const rank = (answers, strict) => products.map((p, idx) => {
      let score = 0; let ok = true;
      answers.forEach((a) => {
        if (a.field !== 'none' && (a.must.some((v) => !has(p, a.field, v)) || a.not.some((v) => has(p, a.field, v)))) ok = false;
        if (!a.values.length || a.field === 'none') return;
        if (a.mode === 'filter') { if (strict && !a.values.every((v) => has(p, a.field, v))) ok = false; else if (a.values.every((v) => has(p, a.field, v))) score += a.weight; }
        else if (a.values.some((v) => has(p, a.field, v))) score += a.weight;
      });
      return { p, score, ok, idx };
    }).filter((r) => r.ok).sort((a, b) => b.score - a.score || a.idx - b.idx);
    const render = () => {
      const answers = collect();
      let list = rank(answers, true);
      if (relax && list.filter((r) => r.score > 0).length < count) {
        const extra = rank(answers, false).filter((r) => !list.some((x) => x.p.id === r.p.id));
        list = list.concat(extra);
      }
      if (onePerFamily) {
        const fams = new Set();
        list = list.filter((r) => { const k = r.p.fam || r.p.id; if (fams.has(k)) return false; fams.add(k); return true; });
      }
      picked = list.slice(0, count).map((r) => r.p);
      items.forEach((el) => (el.hidden = true));
      picked.forEach((p, k) => { const el = items.get(p.id); if (el) { el.hidden = false; el.style.order = k; } });
      if (none) none.hidden = picked.length > 0;
      const kit = root.querySelector('[data-eq-q-kit]');
      if (kit) kit.hidden = picked.length < 2;
      answersEl.innerHTML = '';
      answers.forEach((a) => {
        const li = document.createElement('li');
        const b = document.createElement('button');
        b.type = 'button';
        b.innerHTML = `<span></span><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>`;
        b.firstChild.textContent = a.label;
        b.setAttribute('aria-label', (root.dataset.removeLabel || 'Remover') + ': ' + a.label);
        b.addEventListener('click', () => { a.inp.checked = false; render(); });
        li.appendChild(b);
        answersEl.appendChild(li);
      });
    };
    const finish = () => {
      render();
      stage.hidden = true;
      result.hidden = false;
      result.focus({ preventScroll: true });
      const top = result.getBoundingClientRect().top + scrollY - 120;
      if (top < scrollY) scrollTo({ top, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    };
    root.querySelectorAll('[data-eq-q-restart]').forEach((b) => b.addEventListener('click', () => {
      cards.forEach((c) => c.querySelectorAll('input').forEach((i) => (i.checked = false)));
      result.hidden = true;
      stage.hidden = false;
      show(0);
    }));
    const kit = root.querySelector('[data-eq-q-kit]');
    if (kit) kit.addEventListener('click', async () => {
      if (!picked.length || !window.EQ || !EQ.cart) return;
      const id = 'monte-' + Date.now();
      const itemsToAdd = picked.map((p) => ({ id: p.v, quantity: 1, properties: { _kit: id, _kit_etapa: p.cat || 'Recomendação' } }));
      kit.classList.add('is-loading');
      try { await EQ.cart.add(itemsToAdd, { open: true }); } catch (e) { EQ.toast && EQ.toast(EQ.settings.cartErrorText || 'Erro'); }
      kit.classList.remove('is-loading');
    });
    document.addEventListener('shopify:block:select', (e) => {
      const i = cards.findIndex((c) => c.contains(e.target));
      if (i >= 0) { result.hidden = true; stage.hidden = false; show(i); }
    });
  };
  document.querySelectorAll('[data-eq-quiz2]').forEach(init);
  document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('[data-eq-quiz2]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-kit-builder"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__eqKit) return;
  window.__eqKit = true;
  const KEY = 'eq_kit';
  const money = (c) => (window.EQ ? EQ.money(c) : 'R$ ' + (c / 100).toFixed(2).replace('.', ','));
  const fill = (t, m) => Object.keys(m).reduce((s, k) => s.split(`[${k}]`).join(m[k]), t || '');
  const norm = (t) => String(t || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  const esc = (t) => String(t == null ? '' : t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const ICON = {
    trash: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6"/></svg>',
    minus: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/></svg>',
    plus: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>',
    check: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>',
    arrow: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>',
    info: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8h.01"/></svg>',
    close: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>',
  };
  class Kit {
    constructor(root) {
      this.r = root;
      const d = root.dataset;
      const j = (sel, def) => { try { return JSON.parse(root.querySelector(sel).textContent); } catch (_) { return def; } };
      this.cat = j('[data-eq-kit-catalog]', {});
      this.T = j('[data-eq-kit-text]', {});
      this.steps = j('[data-eq-kit-steps]', []);
      this.n = this.steps.length;
      this.mode = d.mode;
      this.tq = (d.tq || '').split(',').map(Number).filter((x) => x > 0);
      this.tp = (d.tp || '').split(',').map(Number).filter((x) => x > 0);
      this.gift = d.giftId ? { id: Number(d.giftId), price: Number(d.giftPrice) || 0 } : null;
      this.mq = matchMedia('(max-width: 989px)');
      let saved = null;
      try { saved = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (_) {}
      this.st = { items: {}, gift: false, view: 0, max: 0 };
      if (saved && saved.items) {
        Object.keys(saved.items).forEach((k) => { if (this.cat[k]) this.st.items[k] = Math.max(1, Number(saved.items[k]) || 1); });
        this.st.gift = !!saved.gift && !!this.gift;
        this.st.max = Math.min(Number(saved.max) || 0, this.n);
      }
      this.pages = {};
      root.addEventListener('click', (e) => this.onClick(e));
      root.addEventListener('change', (e) => this.onChange(e));
      root.addEventListener('input', (e) => { if (e.target.matches('[data-eq-kit-search]')) this.search(e.target); });
      this.mq.addEventListener('change', () => this.render());
      this.go(0, true);
    }
    save() { try { localStorage.setItem(KEY, JSON.stringify({ items: this.st.items, gift: this.st.gift, max: this.st.max })); } catch (_) {} }
    count() { return Object.values(this.st.items).reduce((a, b) => a + b, 0); }
    subtotal() { return Object.keys(this.st.items).reduce((a, k) => a + (this.cat[k] ? this.cat[k].p * this.st.items[k] : 0), 0); }
    pct(n) { let p = 0; this.tq.forEach((q, i) => { if (n >= q) p = this.tp[i] || 0; }); return p; }
    nextTier(n) { for (let i = 0; i < this.tq.length; i++) if (n < this.tq[i]) return { need: this.tq[i] - n, pct: this.tp[i] || 0 }; return null; }
    totals() {
      const n = this.count(), sub = this.subtotal(), pct = this.pct(n);
      /* produto sem desconto (nd) conta como item, mas o % não incide sobre ele */
      const base = Object.keys(this.st.items).reduce((a, k) => a + (this.cat[k] && !this.cat[k].nd ? this.cat[k].p * this.st.items[k] : 0), 0);
      const disc = Math.round((base * pct) / 100);
      const gift = this.st.gift && this.gift ? this.gift.price : 0;
      return { n, sub, pct, disc, gift, total: sub - disc + gift };
    }
    itemsWord(n) { return n === 1 ? this.T.word_item : this.T.word_items; }
    stepCount(i) { return Object.keys(this.st.items).filter((k) => this.cat[k] && this.cat[k].s === i).reduce((a, k) => a + this.st.items[k], 0); }
    /* navegação */
    go(v, first) {
      if (v === 'review') v = this.n;
      v = Math.max(0, Math.min(this.n, Number(v)));
      this.st.view = v;
      this.st.max = Math.max(this.st.max, v);
      this.r.querySelectorAll('[data-eq-kit-step]').forEach((p) => (p.hidden = (p.dataset.eqKitStep === 'review' ? this.n : Number(p.dataset.eqKitStep)) !== v));
      const sh = document.getElementById('KitSheet-' + this.r.dataset.uid);
      if (sh && sh.classList.contains('is-open') && window.EQ) window.EQ.close(sh.id);
      this.render();
      this.save();
      if (!first) {
        const nav = this.r.querySelector('.eq-kit__nav');
        const top = nav.getBoundingClientRect().top + window.scrollY - (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--eq-header-h')) || 80) - 16;
        if (window.scrollY > top) window.scrollTo({ top, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
    }
    /* quantidade */
    setQty(key, q) {
      if (!this.cat[key]) return;
      if (q <= 0) delete this.st.items[key]; else this.st.items[key] = q;
      this.save();
      this.render();
    }
    onChange(e) {
      const t = e.target;
      if (t.matches('[data-eq-kit-var]')) { this.paintCard(t.closest('[data-eq-kcard]')); return; }
      if (t.matches('[data-eq-kit-gift]')) { this.st.gift = t.checked; this.save(); this.render(); }
    }
    onClick(e) {
      const t = e.target;
      const g = t.closest('[data-eq-kit-go]');
      if (g && !g.disabled) { this.go(g.dataset.eqKitGo); return; }
      const add = t.closest('[data-eq-kit-add]');
      if (add) { const card = add.closest('[data-eq-kcard]'); const k = this.cardKey(card); this.setQty(k, (this.st.items[k] || 0) + 1); const q = card.querySelector('[data-eq-kit-q] [data-d="1"]'); if (q) q.focus(); return; }
      const q = t.closest('[data-eq-kit-qd]');
      if (q) { const k = q.dataset.key || this.cardKey(q.closest('[data-eq-kcard]')); this.setQty(k, (this.st.items[k] || 0) + Number(q.dataset.eqKitQd)); return; }
      const a = t.closest('[data-eq-kit-act]');
      if (a) { this.act(a.dataset.eqKitAct, a); return; }
      const m = t.closest('[data-eq-kit-bmain]');
      if (m) { this.act(m.dataset.act, m); return; }
      const pg = t.closest('[data-eq-kit-page]');
      if (pg) { const box = pg.closest('[data-eq-kit-pages]'); const id = box.closest('[data-eq-kit-step]').dataset.eqKitStep; const v = pg.dataset.eqKitPage; const cur = this.pages[id] || 1; this.pages[id] = v === 'prev' ? cur - 1 : v === 'next' ? cur + 1 : Number(v); this.paginate(box); box.scrollIntoView({ block: 'start', behavior: 'smooth' }); return; }
      const more = t.closest('[data-eq-kit-more]');
      if (more) { const box = more.closest('[data-eq-kit-pages]'); const id = box.closest('[data-eq-kit-step]').dataset.eqKitStep; this.pages['m' + id] = (this.pages['m' + id] || 1) + 1; this.paginate(box); }
    }
    async act(what, btn) {
      if (what === 'next') { this.go(this.st.view + 1); return; }
      if (what === 'review') { this.go(this.n); return; }
      if (what === 'close') { EQ.close('KitSheet-' + this.r.dataset.uid); return; }
      if (what === 'add') {
        const n = this.count();
        if (!n) { this.go(0); return; }
        const id = 'monte-' + Date.now().toString(36);
        const items = Object.keys(this.st.items).map((k) => ({ id: this.cat[k].id, quantity: this.st.items[k], properties: { _kit: id, _kit_etapa: (this.steps[this.cat[k].s] || {}).label || '' } }));
        if (this.st.gift && this.gift) items.push({ id: this.gift.id, quantity: 1, properties: { _kit: id, _kit_etapa: this.T.gift_title || 'Adicionais' } });
        this.r.querySelectorAll('[data-eq-kit-act="add"], [data-eq-kit-bmain]').forEach((b) => { b.classList.add('is-loading'); b.disabled = true; });
        try {
          await EQ.cart.add(items);
          this.st.items = {}; this.st.gift = false; this.st.max = 0; this.save();
          if (EQ.toast) EQ.toast(this.T.added_text);
          this.go(0, true);
        } catch (err) { if (EQ.toast) EQ.toast(err.message); }
        this.r.querySelectorAll('[data-eq-kit-act="add"], [data-eq-kit-bmain]').forEach((b) => { b.classList.remove('is-loading'); b.disabled = false; });
        this.render();
      }
    }
    cardKey(card) { const sel = card.querySelector('[data-eq-kit-var]'); return sel.value + '-' + card.dataset.step; }
    paintCard(card) {
      const k = this.cardKey(card);
      const q = this.st.items[k] || 0;
      const sel = card.querySelector('[data-eq-kit-var]');
      const o = sel.tagName === 'SELECT' ? sel.selectedOptions[0] : sel;
      card.querySelector('[data-eq-kit-price]').textContent = money(Number(o.dataset.price) || 0);
      const dose = card.querySelector('[data-eq-kit-dose]');
      if (dose) { dose.textContent = o.dataset.dose || ''; dose.hidden = !o.dataset.dose; }
      const anyQ = [...(sel.tagName === 'SELECT' ? sel.options : [sel])].some((op) => this.st.items[op.value + '-' + card.dataset.step]);
      card.classList.toggle('is-on', anyQ);
      const addB = card.querySelector('[data-eq-kit-add]');
      const qty = card.querySelector('[data-eq-kit-q]');
      addB.hidden = q > 0;
      addB.disabled = o.dataset.avail === 'false' && !addB.dataset.eqNotify;
      qty.hidden = q === 0;
      qty.querySelector('span').textContent = q;
      qty.querySelector('[data-d="-1"]').innerHTML = q <= 1 ? ICON.trash : ICON.minus;
      qty.querySelector('[data-d="-1"]').setAttribute('aria-label', q <= 1 ? this.T.remove_label : this.T.less_label);
    }
    search(inp) {
      const step = inp.closest('[data-eq-kit-step]');
      const words = norm(inp.value).split(/\s+/).filter(Boolean);
      let shown = 0;
      step.querySelectorAll('[data-eq-kcard]').forEach((c) => { const on = words.every((w) => norm(c.dataset.search).includes(w)); c.dataset.match = on ? '1' : '0'; if (on) shown++; });
      step.dataset.searching = words.length ? '1' : '';
      step.querySelectorAll('.eq-kit__sub').forEach((sub) => { const any = [...sub.querySelectorAll('[data-eq-kcard]')].some((c) => c.dataset.match !== '0'); sub.hidden = !any; });
      step.querySelector('[data-eq-kit-noresult]').hidden = shown > 0;
      step.querySelectorAll('[data-eq-kit-pages]').forEach((b) => this.paginate(b));
      step.querySelectorAll('.eq-kit__sub:not([data-eq-kit-pages]) [data-eq-kcard]').forEach((c) => (c.hidden = c.dataset.match === '0'));
    }
    paginate(box) {
      const step = box.closest('[data-eq-kit-step]');
      const id = step.dataset.eqKitStep;
      const cards = [...box.querySelectorAll('[data-eq-kcard]')].filter((c) => c.dataset.match !== '0');
      const all = box.querySelectorAll('[data-eq-kcard]');
      const per = this.mq.matches ? Number(this.r.dataset.perM) || 6 : Number(this.r.dataset.per) || 6;
      const foot = box.querySelector('[data-eq-kit-pfoot]');
      all.forEach((c) => (c.hidden = true));
      if (step.dataset.searching) { cards.forEach((c) => (c.hidden = false)); foot.hidden = true; return; }
      const pages = Math.max(1, Math.ceil(cards.length / per));
      let p = Math.min(Math.max(1, this.pages[id] || 1), pages);
      this.pages[id] = p;
      if (this.mq.matches) {
        const m = this.pages['m' + id] || 1;
        cards.forEach((c, i) => (c.hidden = i >= m * per));
        foot.hidden = cards.length <= m * per;
        return;
      }
      cards.forEach((c, i) => (c.hidden = !(i >= (p - 1) * per && i < p * per)));
      foot.hidden = pages <= 1;
      foot.querySelector('[data-eq-kit-pn]').textContent = Math.min(per, cards.length);
      foot.querySelector('[data-eq-kit-pof]').textContent = fill(this.T.showing_suffix, { n: cards.length });
      foot.querySelector('[data-eq-kit-page="prev"]').disabled = p <= 1;
      foot.querySelector('[data-eq-kit-page="next"]').disabled = p >= pages;
      const arr = [];
      for (let i = 1; i <= pages; i++) if (i === 1 || i === pages || Math.abs(i - p) <= 1 || pages <= 5) arr.push(i); else if (arr[arr.length - 1] !== '…') arr.push('…');
      foot.querySelector('[data-eq-kit-pnums]').innerHTML = arr.map((n) => (n === '…' ? '<span>…</span>' : `<button type="button" data-eq-kit-page="${n}"${n === p ? ' aria-current="page"' : ''}>${n}</button>`)).join('');
    }
    qtyHTML(k, q) {
      return `<span class="eq-kit__qty"><button type="button" data-eq-kit-qd="-1" data-key="${k}" aria-label="${esc(q <= 1 ? this.T.remove_label : this.T.less_label)}">${q <= 1 ? ICON.trash : ICON.minus}</button><span>${q}</span><button type="button" data-eq-kit-qd="1" data-key="${k}" aria-label="${esc(this.T.more_label)}">${ICON.plus}</button></span>`;
    }
    lineName(c) { return c.vt ? `${c.t} · ${c.vt}` : c.t; }
    summaryHTML(sheet) {
      const T = this.T, t = this.totals(), review = this.st.view === this.n;
      let h = `<div class="eq-kit__sumhead"><h2>${esc(T.summary_title)}</h2><span>${t.n} ${esc(this.itemsWord(t.n))}</span>${sheet ? `<button type="button" class="eq-kit__sumclose" data-eq-kit-act="close" aria-label="${esc(T.close_label)}">${ICON.close}</button>` : ''}</div><hr class="eq-kit__hr">`;
      if (!t.n) h += `<p class="eq-kit__empty">${esc(T.summary_empty)}</p>`;
      else {
        this.steps.forEach((s, i) => {
          const keys = Object.keys(this.st.items).filter((k) => this.cat[k] && this.cat[k].s === i);
          if (!keys.length) return;
          const lab = sheet ? `${String(i + 1).padStart(2, '0')} · ${esc(s.label)}` : esc(s.label);
          h += `<div class="eq-kit__grp"><div class="eq-kit__grph"><span>${lab}</span><button type="button" class="eq-kit__lnk" data-eq-kit-go="${i}">${esc(T.change_label)}</button></div>`;
          keys.forEach((k) => { const c = this.cat[k]; h += `<div class="eq-kit__line">${c.img ? `<img src="${c.img}" alt="" width="40" height="40" loading="lazy">` : ''}<span class="eq-kit__ltext"><span class="eq-kit__lname">${esc(this.lineName(c))}</span><span class="eq-kit__lprice">${money(c.p)}</span></span>${this.qtyHTML(k, this.st.items[k])}</div>`; });
          h += `</div>`;
        });
      }
      if (this.tq.length) {
        const nx = this.nextTier(t.n);
        h += `<hr class="eq-kit__hr"><div class="eq-kit__tiers"><p>${esc(T.tiers_title)}</p><div class="eq-kit__chips" style="--n:${this.tq.length}">`;
        this.tq.forEach((q, i) => {
          const on = t.n >= q, next = nx && nx.pct === this.tp[i] && !on;
          const sub = i === this.tq.length - 1 ? fill(T.tier_last, { n: q }) : fill(T.tier_sub, { n: q });
          h += `<div class="eq-kit__tier${on ? ' is-on' : next ? ' is-next' : ''}"><strong>${ICON.check}${this.tp[i]}%</strong><span>${esc(sub)}</span></div>`;
        });
        h += `</div>${nx ? `<p class="eq-kit__inc">${esc(fill(T.tier_incentive, { n: nx.need, item: nx.need === 1 ? T.word_item : T.word_items, pct: nx.pct }))}</p>` : ''}</div>`;
      }
      if (this.gift && T.gift_show !== false) {
        h += `<hr class="eq-kit__hr"><div class="eq-kit__add"><p>${esc(T.gift_title)}</p><label class="eq-kit__gift eq-check"><input type="checkbox" data-eq-kit-gift${this.st.gift ? ' checked' : ''}><b>${esc(T.gift_label)}</b><em>${money(this.gift.price)}</em>${T.gift_desc ? `<small>${esc(T.gift_desc)}</small>` : ''}</label></div>`;
      }
      h += `<hr class="eq-kit__hr"><div class="eq-kit__tot"><div><span>${esc(fill(T.subtotal_label, { n: t.n, itens: this.itemsWord(t.n) }))}</span><span>${money(t.sub)}</span></div>`;
      if (this.tq.length) h += `<div><span>${esc(T.discount_label)}</span><span>${t.pct}% · -${money(t.disc)}</span></div>`;
      if (t.gift) h += `<div><span>${esc(T.gift_label)}</span><span>${money(t.gift)}</span></div>`;
      h += `<div class="is-total"><span>${esc(T.total_label)}</span><strong>${money(t.total)}</strong></div></div>`;
      if (review) {
        if (T.legal_note) h += `<p class="eq-kit__legal">${esc(T.legal_note)}</p>`;
        h += `<button type="button" class="eq-btn eq-btn--primary eq-btn--g eq-btn--full" data-eq-kit-act="add"${t.n ? '' : ' disabled'}>${esc(T.btn_add_kit)}${ICON.arrow}</button>`;
      } else if (sheet) {
        const last = this.st.view >= this.n - 1;
        h += `<button type="button" class="eq-btn eq-btn--primary eq-btn--m eq-btn--full" data-eq-kit-act="${last ? 'review' : 'next'}">${esc(last ? T.btn_finish : T.btn_next)}${ICON.arrow}</button>`;
        if (!last) h += `<button type="button" class="eq-kit__sumlink" data-eq-kit-act="review">${esc(T.btn_review)}${ICON.arrow}</button>`;
      }
      return h;
    }
    reviewHTML() {
      const T = this.T;
      return this.steps.map((s, i) => {
        const keys = Object.keys(this.st.items).filter((k) => this.cat[k] && this.cat[k].s === i);
        let h = `<div class="eq-kit__rsec${keys.length ? ' has-items' : ''}"><div class="eq-kit__rhead"><span>${String(i + 1).padStart(2, '0')} · ${esc(s.label)}</span><button type="button" class="eq-kit__lnk" data-eq-kit-go="${i}">${esc(keys.length ? T.review_see_all : T.review_add)}</button></div>`;
        if (!keys.length) h += `<p class="eq-kit__rempty">${esc(T.review_empty)}</p>`;
        keys.forEach((k) => { const c = this.cat[k]; h += `<div class="eq-kit__rline">${c.img ? `<img src="${c.img}" alt="" width="64" height="64" loading="lazy">` : ''}<span class="eq-kit__ltext"><span class="eq-kit__lname">${esc(this.lineName(c))}</span><span class="eq-kit__lprice">${money(c.p)}</span></span>${this.qtyHTML(k, this.st.items[k])}</div>`; });
        return h + '</div>';
      }).join('');
    }
    nudgeHTML(i) {
      const T = this.T, t = this.totals(), nx = this.nextTier(t.n), ns = this.steps[i + 1];
      const title = t.n === 0 ? T.nudge_title_empty || T.nudge_title_first : t.n === 1 ? T.nudge_title_first : T.nudge_title_next;
      let text = nx ? fill(T.nudge_text, { n: nx.need, item: nx.need === 1 ? T.word_item : T.word_items, pct: nx.pct }) : fill(T.nudge_max, { pct: t.pct });
      if (ns && ns.phrase) text += ' ' + ns.phrase;
      const imgs = ns && T.nudge_show_images ? ns.imgs.map((u) => `<img src="${u}" alt="" width="56" height="56" loading="lazy">`).join('') : '';
      const over = ns && T.nudge_overline ? `<p class="eq-kit__nover">${esc(fill(T.nudge_overline, { i: i + 2, total: this.n }))}</p>` : '';
      const btn = T.nudge_show_button ? `<button type="button" class="eq-btn eq-btn--tertiary eq-btn--m" data-eq-kit-go="${ns ? i + 1 : 'review'}">${esc(ns ? fill(T.nudge_button, { etapa: ns.label }) : T.btn_review)}</button>` : '';
      return `<div class="eq-kit__nmain">${imgs ? `<span class="eq-kit__navs">${imgs}</span>` : ''}<div class="eq-kit__ntext">${over}<p class="eq-kit__ntitle">${esc(title)}</p><p class="eq-kit__ndesc">${esc(text)}</p></div></div>${btn}`;
    }
    render() {
      const T = this.T, v = this.st.view, t = this.totals(), review = v === this.n, last = v === this.n - 1;
      /* nav */
      this.r.querySelectorAll('[data-eq-kit-st]').forEach((li) => {
        const i = Number(li.dataset.eqKitSt);
        li.classList.toggle('is-current', i === v);
        li.classList.toggle('is-done', i !== v && (i === this.n ? false : this.stepCount(i) > 0));
        const b = li.querySelector('button');
        b.disabled = i === v;
        if (i === v) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current');
      });
      const cur = this.r.querySelector('[data-eq-kit-stcur]');
      if (cur) cur.textContent = review ? T.review_step_label : (this.steps[v] || {}).label || '';
      this.r.querySelectorAll('.eq-kit__tab').forEach((b) => {
        const i = Number(b.dataset.eqKitGo);
        b.setAttribute('aria-selected', i === v ? 'true' : 'false');
        b.classList.toggle('is-active', i === v);
        const n = this.stepCount(i), tn = b.querySelector('[data-eq-kit-tabn]');
        tn.hidden = !n; tn.textContent = n ? `(${n})` : '';
      });
      /* cards e nudge */
      this.r.querySelectorAll('[data-eq-kcard]').forEach((c) => this.paintCard(c));
      this.r.querySelectorAll('[data-eq-kit-step]').forEach((p) => {
        if (p.dataset.eqKitStep === 'review') return;
        const i = Number(p.dataset.eqKitStep);
        const nd = p.querySelector('[data-eq-kit-nudge]');
        const show = T.nudge_enabled !== false;
        nd.hidden = !show;
        if (show && i === v) nd.innerHTML = this.nudgeHTML(i);
        p.querySelectorAll('[data-eq-kit-pages]').forEach((b) => this.paginate(b));
      });
      /* revisão */
      if (review) {
        this.r.querySelector('[data-eq-kit-rlist]').innerHTML = this.reviewHTML();
        this.r.querySelector('[data-eq-kit-rcount]').textContent = fill(T.review_count, { n: t.n, itens: this.itemsWord(t.n) });
      }
      /* resumo */
      this.r.querySelectorAll('[data-eq-kit-sum]').forEach((s) => (s.innerHTML = this.summaryHTML(s.hasAttribute('data-sheet'))));
      /* barra */
      const nx = this.nextTier(t.n);
      this.r.querySelector('[data-eq-kit-btotal]').textContent = money(t.total);
      let sub = t.n ? fill(review ? T.bar_sub_review : T.bar_sub, { n: t.n, itens: this.itemsWord(t.n), pct: t.pct }) : T.bar_empty;
      if (t.n && !t.pct) sub = fill(T.bar_sub_nodisc, { n: t.n, itens: this.itemsWord(t.n) });
      if (t.gift && !review) sub += T.bar_gift;
      this.r.querySelector('[data-eq-kit-bsub]').textContent = sub;
      this.r.querySelector('[data-eq-kit-blink]').innerHTML = esc(fill(T.bar_link, { n: t.n, itens: this.itemsWord(t.n) })) + ' ' + ICON.arrow;
      const inc = this.r.querySelector('[data-eq-kit-binc]');
      inc.textContent = !review && nx ? fill(t.n ? T.bar_incentive : T.tier_incentive, { n: nx.need, item: nx.need === 1 ? T.word_item : T.word_items, pct: nx.pct }) : '';
      inc.classList.toggle('is-strong', t.n > 0);
      const rb = this.r.querySelector('[data-eq-kit-breview]');
      const rbMode = this.r.dataset.reviewBtn;
      const showRb = !review && !last && (rbMode === 'always' || (rbMode === 'auto' && (this.mode === 'tabs' || t.n > 0)));
      rb.hidden = !showRb;
      rb.disabled = t.n === 0;
      const main = this.r.querySelector('[data-eq-kit-bmain]');
      const ml = main.querySelector('[data-eq-kit-bmainl]');
      if (review) { main.dataset.act = 'add'; ml.textContent = this.mq.matches ? T.btn_add_short : T.btn_add_kit; main.disabled = t.n === 0; }
      else if (last) { main.dataset.act = 'review'; ml.textContent = this.mq.matches ? T.btn_finish : T.btn_review; main.disabled = false; }
      else { main.dataset.act = 'next'; ml.textContent = this.stepCount(v) ? T.btn_next : T.btn_skip; main.disabled = false; }
    }
  }
  const init = () => document.querySelectorAll('[data-eq-kit]').forEach((r) => { if (!r.dataset.ready) { r.dataset.ready = '1'; r._kit = new Kit(r); } });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-lp-sub-calc"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    const $ = (q) => root.querySelector(q);
    const freqs = (root.dataset.freqs || '15,30,45,60').split(',').map(Number).filter(Boolean).sort((a, b) => a - b);
    const fill = (t, d, f) => (t || '').replace(/\[dias\]/g, d).replace(/\[freq\]/g, f);
    const calc = () => {
      const opt = $('[data-eq-lpc-product]').selectedOptions[0];
      if (!opt) return;
      const doses = Number(opt.dataset.doses) || 0;
      const perDay = Number($('[data-eq-lpc-doses]').value) || 1;
      const perWeek = Number($('[data-eq-lpc-days]').value) || 7;
      const days = Math.max(1, Math.floor(doses / ((perDay * perWeek) / 7)));
      let freq = freqs[0];
      freqs.forEach((f) => { if (f <= days) freq = f; });
      $('[data-eq-lpc-line1]').textContent = fill(root.dataset.tLine1, days, freq);
      $('[data-eq-lpc-accent]').textContent = fill(root.dataset.tAccent, days, freq);
      $('[data-eq-lpc-days-out]').textContent = `${days} ${root.dataset.tDays || 'dias'}`;
      const max = freqs[freqs.length - 1];
      $('[data-eq-lpc-bar]').style.setProperty('--p', Math.min(100, (days / max) * 100) + '%');
      $('[data-eq-lpc-marks]').innerHTML = [`<li>${root.dataset.tToday || 'Hoje'}</li>`].concat(freqs.map((f) => `<li class="${f === freq ? 'is-on' : ''}">${f} ${root.dataset.tDays || 'dias'}</li>`)).join('');
      $('[data-eq-lpc-cta-text]').textContent = fill(root.dataset.tCta, days, freq);
      const note = $('[data-eq-lpc-note]');
      if (note) note.textContent = fill(root.dataset.tNote, days, freq);
      let url = opt.dataset.url;
      const plan = (opt.dataset.plans || '').split('|').filter(Boolean).map((x) => x.split(':')).find(([, name]) => new RegExp(`\\b${freq}\\b`).test(name));
      if (plan) url += (url.includes('?') ? '&' : '?') + 'selling_plan=' + plan[0];
      $('[data-eq-lpc-cta]').href = url;
    };
    root.addEventListener('change', calc);
    $('[data-eq-lpc-form]').addEventListener('submit', (e) => { e.preventDefault(); calc(); const r = $('[data-eq-lpc-result]'); if (r && r.getBoundingClientRect().top > innerHeight * 0.7) r.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' }); });
    calc();
  };
  const boot = () => document.querySelectorAll('[data-eq-lpc]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-lp-sub-faq"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.addEventListener('click', (e) => {
    const chip = e.target.closest('[data-eq-faq-tag]');
    if (!chip) return;
    const root = chip.closest('[data-eq-lps-faq]');
    const tag = chip.dataset.eqFaqTag;
    root.querySelectorAll('[data-eq-faq-tag]').forEach((c) => { const on = c === chip; c.classList.toggle('is-active', on); c.setAttribute('aria-pressed', on); });
    root.querySelectorAll('details[data-tags]').forEach((d) => { d.hidden = !!tag && !d.dataset.tags.includes(`|${tag}|`); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-page-top"] && !Shopify.designMode) return;
  try {
    
(() => {
  const go = () => document.querySelectorAll('[data-eq-ptop-chips]').forEach((w) => {
    const a = w.querySelector('.is-active');
    if (a && w.scrollWidth > w.clientWidth) w.scrollLeft = a.offsetLeft - 24;
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-pdp-anchors"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('eq-pdp-tabs')) return;
  class EqPdpTabs extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = '1';
      this.bar = this.querySelector('.eq-pdp-tabs__bar');
      this.list = this.querySelector('.eq-pdp-tabs__list');
      this.tabs = [...this.querySelectorAll('[data-eq-tab-target]')];
      this.tabs.forEach((t) => {
        const g = document.querySelectorAll(`[data-eq-pdp-group="${t.dataset.eqTabTarget}"]`);
        if (!g.length) t.hidden = true;
        t.addEventListener('click', (e) => {
          const el = this.target(t.dataset.eqTabTarget);
          if (!el) return;
          e.preventDefault();
          const off = this.headerH() + this.bar.offsetHeight - 1;
          const y = el.getBoundingClientRect().top + scrollY - off;
          scrollTo({ top: y, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
          history.replaceState(history.state, '', '#eq-pdp-' + t.dataset.eqTabTarget);
        });
      });
      this.visible = this.tabs.filter((t) => !t.hidden);
      if (!this.visible.length) { this.closest('[data-eq-pdp-tabs-wrap]').hidden = true; return; }
      this.onScroll = () => { if (!this.raf) this.raf = requestAnimationFrame(() => { this.raf = 0; this.update(); }); };
      addEventListener('scroll', this.onScroll, { passive: true });
      addEventListener('resize', this.onScroll);
      this.update();
    }
    disconnectedCallback() { removeEventListener('scroll', this.onScroll); removeEventListener('resize', this.onScroll); }
    headerH() { return parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--eq-header-h')) || 0; }
    target(g) { return document.querySelector(`[data-eq-pdp-group="${g}"]`); }
    groupsEnd() {
      const all = [...document.querySelectorAll('[data-eq-pdp-group]')];
      return all.length ? all[all.length - 1].getBoundingClientRect().bottom : 0;
    }
    update() {
      const hh = this.headerH();
      const bh = this.bar.offsetHeight;
      const top = this.getBoundingClientRect().top;
      const fixed = this.dataset.sticky !== 'false' && top < hh && this.groupsEnd() > hh + bh;
      this.classList.toggle('is-fixed', fixed);
      const line = hh + bh + 8;
      let cur = this.visible[0];
      this.visible.forEach((t) => {
        const els = document.querySelectorAll(`[data-eq-pdp-group="${t.dataset.eqTabTarget}"]`);
        if (els.length && els[0].getBoundingClientRect().top <= line) cur = t;
      });
      if (cur !== this.cur) {
        this.tabs.forEach((t) => { t.classList.toggle('is-active', t === cur); t.toggleAttribute('aria-current', t === cur); });
        this.cur = cur;
        if (cur && this.list.scrollWidth > this.list.clientWidth) this.list.scrollTo({ left: cur.offsetLeft - 12, behavior: 'smooth' });
      }
    }
  }
  customElements.define('eq-pdp-tabs', EqPdpTabs);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-pdp-faq"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__eqPdpFaq) return;
  window.__eqPdpFaq = true;
  const mq = matchMedia('(min-width: 990px)');
  const paint = (sec) => {
    const tag = sec.dataset.tag || '';
    const all = sec.classList.contains('is-all');
    const lim = Number(mq.matches ? sec.dataset.limD : sec.dataset.limM);
    const qs = [...sec.querySelectorAll('.eq-pdp-faq__q')];
    let shown = 0;
    let hiddenByLimit = 0;
    qs.forEach((q) => {
      const match = !tag || (q.dataset.tags || '').split('|').includes(tag);
      let vis = match;
      if (match && !tag && !all && shown >= lim) { vis = false; hiddenByLimit++; }
      q.hidden = !vis;
      if (vis) shown++;
    });
    sec.classList.toggle('is-filtered', !!tag);
    const more = sec.querySelector('[data-eq-faq-all]');
    if (more) more.hidden = hiddenByLimit === 0;
  };
  const boot = () => document.querySelectorAll('[data-eq-pfaq]').forEach(paint);
  document.addEventListener('click', (e) => {
    const f = e.target.closest('[data-eq-faq-filter]');
    if (f) {
      const sec = f.closest('[data-eq-pfaq]');
      sec.dataset.tag = f.dataset.eqFaqFilter;
      sec.querySelectorAll('[data-eq-faq-filter]').forEach((x) => x.setAttribute('aria-pressed', x === f));
      paint(sec);
      return;
    }
    const m = e.target.closest('[data-eq-faq-all]');
    if (m) {
      const sec = m.closest('[data-eq-pfaq]');
      sec.classList.add('is-all');
      m.setAttribute('aria-expanded', 'true');
      paint(sec);
    }
  });
  mq.addEventListener('change', boot);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-pdp-kits"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__eqPdpKits) return;
  window.__eqPdpKits = true;
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-eq-kit-filter]');
    if (!b) return;
    const sec = b.closest('.eq-pdp-kits');
    const tag = b.dataset.eqKitFilter;
    sec.querySelectorAll('[data-eq-kit-filter]').forEach((x) => x.setAttribute('aria-pressed', x === b));
    sec.querySelectorAll('[data-eq-kit]').forEach((k) => { k.hidden = !!tag && !(k.dataset.tags || '').split('|').includes(tag); });
    sec.querySelectorAll('eq-carousel').forEach((c) => c.build && c.build());
  });
  document.addEventListener('eq:cart:updated', (e) => {
    const ids = ((e.detail && e.detail.items) || []).map((i) => String(i.product_id));
    const here = document.querySelector('[data-eq-pdp-json]');
    let pid = '';
    try { pid = String(JSON.parse(here.textContent).id); } catch (_) {}
    document.querySelectorAll('[data-eq-kit-pid]').forEach((it) => {
      const badge = it.querySelector('[data-eq-kit-here]');
      if (badge) badge.hidden = !(ids.includes(it.dataset.eqKitPid) || it.dataset.eqKitPid === pid);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-pdp-nutrition"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__eqPdpNut) return;
  window.__eqPdpNut = true;
  document.addEventListener('eq:pdp:state', (e) => {
    const id = e.detail && e.detail.variant && String(e.detail.variant.id);
    if (!id) return;
    document.querySelectorAll('[data-eq-nut]').forEach((box) => {
      const tabs = [...box.querySelectorAll('[data-eq-nut-ids]')];
      const hit = tabs.find((t) => t.dataset.eqNutIds.split(',').includes(id));
      if (hit) tabs.forEach((t) => (t.hidden = t !== hit));
    });
    document.querySelectorAll('[data-eq-varsw]').forEach((box) => {
      const items = [...box.querySelectorAll('[data-eq-var-ids]')];
      const hit = items.find((t) => t.dataset.eqVarIds.split(',').includes(id));
      if (hit) items.forEach((t) => (t.hidden = t !== hit));
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-pdp-overview"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__eqVarSw) return;
  window.__eqVarSw = true;
  document.addEventListener('eq:pdp:state', (e) => {
    const id = e.detail && e.detail.variant && String(e.detail.variant.id);
    if (!id) return;
    document.querySelectorAll('[data-eq-varsw]').forEach((box) => {
      const items = [...box.querySelectorAll('[data-eq-var-ids]')];
      const hit = items.find((t) => t.dataset.eqVarIds.split(',').includes(id));
      if (hit) items.forEach((t) => (t.hidden = t !== hit));
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-pdp-related"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__eqPdpRel) return;
  window.__eqPdpRel = true;
  const load = async (sec) => {
    if (sec.dataset.loaded) return;
    sec.dataset.loaded = '1';
    const box = sec.querySelector('[data-eq-recs]');
    if (box.querySelector('[data-eq-recs-ready]')) { sec.hidden = false; return; }
    try {
      const html = await fetch(sec.dataset.url).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-eq-recs]');
      if (fresh && fresh.querySelector('[data-eq-recs-ready]')) {
        box.innerHTML = fresh.innerHTML;
        sec.hidden = false;
        if (window.EQ && EQ.paintFavs) EQ.paintFavs();
      } else {
        sec.classList.add('no-recs');
      }
    } catch (_) { sec.classList.add('no-recs'); }
  };
  const boot = () => document.querySelectorAll('[data-eq-rel]').forEach(load);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', (e) => { const s = e.target.querySelector('[data-eq-rel]'); if (s) load(s); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-pdp-sticky"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('eq-pdp-bar')) return;
  const money = (c) => (window.EQ ? EQ.money(c) : 'R$ ' + (c / 100).toFixed(2).replace('.', ','));
  class EqPdpBar extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = '1';
      this.btn = this.querySelector('[data-eq-bar-add]');
      this.btn.addEventListener('click', () => document.dispatchEvent(new CustomEvent('eq:pdp:add')));
      this.querySelectorAll('[data-eq-bar-opt]').forEach((sel) => sel.addEventListener('change', () => document.dispatchEvent(new CustomEvent('eq:pdp:select', { detail: { value: sel.value } }))));
      try { this.names = JSON.parse(this.querySelector('[data-eq-pdp-names]').textContent); } catch (e) { this.names = {}; }
      this.h1 = document.querySelector('.eq-pdp-buy__title');
      document.addEventListener('eq:pdp:state', (e) => this.paint(e.detail));
      document.addEventListener('eq:pdp:busy', (e) => this.btn.classList.toggle('is-loading', !!e.detail));
      const target = document.querySelector('[data-eq-pdp-add]') || document.querySelector('#eq-pdp-buy');
      if (!target) return;
      const footer = document.querySelector('footer, .eq-footer');
      let ctaGone = false;
      let atFooter = false;
      const set = () => {
        const on = ctaGone && !atFooter;
        this.classList.toggle('is-on', on);
        this.setAttribute('aria-hidden', on ? 'false' : 'true');
        this.btn.tabIndex = on ? 0 : -1;
        this.querySelectorAll('select').forEach((s) => (s.tabIndex = on ? 0 : -1));
        document.documentElement.classList.toggle('eq-pdp-bar-on', on);
      };
      new IntersectionObserver(([en]) => { ctaGone = !en.isIntersecting && en.boundingClientRect.top < 0; set(); }).observe(target);
      if (footer) new IntersectionObserver(([en]) => { atFooter = en.isIntersecting; set(); }).observe(footer);
    }
    paint(st) {
      if (!st || !st.variant) return;
      const v = st.variant;
      /* título comercial da variante (H1 da caixa de compra, título da barra e aba do navegador) */
      const nome = (this.names && this.names[v.id]) || this.dataset.productTitle || '';
      if (nome) {
        [this.h1, this.querySelector('[data-eq-pdp-title]')].forEach((el) => { if (el && el.textContent !== nome) el.textContent = nome; });
        if (!this._docTitle) this._docTitle = document.title;
        const pt = this.dataset.productTitle;
        const cut = this._docTitle.lastIndexOf(' – ');
        document.title = nome + (cut > 0 ? this._docTitle.slice(cut) : '');
      }
      const unit = st.plan ? st.plan.price : v.price;
      const p = this.querySelector('[data-eq-bar-price]');
      if (p) p.textContent = money(unit);
      const pix = Number(this.dataset.pix || 0);
      const px = this.querySelector('[data-eq-bar-pix]');
      const pixPrice = this.dataset.mobilePrice === 'pix' && !st.plan && pix > 0;
      if (px) px.textContent = money(pixPrice ? Math.round((v.price * (100 - pix)) / 100) : unit);
      const note = this.querySelector('[data-eq-bar-note]');
      if (note) {
        const n = Math.min(Number(this.dataset.instMax), Math.floor(unit / Math.max(1, Number(this.dataset.instMin))));
        const raw = (this.dataset.mobileText || '').replace(/\[pct\]/g, pix);
        const sep = (raw.match(/[·•]/) || ['•'])[0];
        const parts = raw.split(/\s*[·•]\s*/).filter((x) => x && !((st.plan || !pix) && /pix/i.test(x)) && !(n < 2 && x.indexOf('[n]') >= 0));
        let t = parts.map((x) => x.replace('[n]', n)).join(' ' + sep + ' ');
        if (parts.length && !/pix/i.test(parts[0])) t = t.replace(/^ou\s+/i, '').replace(/^./, (c) => c.toUpperCase());
        note.textContent = t;
      }
      const sum = this.querySelector('[data-eq-bar-sum]');
      if (sum) {
        const parts = [];
        if (st.summary) parts.push(...st.summary);
        else if (v.title && v.title !== 'Default Title') parts.push(v.title.split(' / ').join(' · '));
        if (v.rotulo) parts.push(v.rotulo);
        if (st.label) parts.push(st.label);
        parts.push(st.qty + ' ' + (st.qty === 1 ? this.dataset.unit : this.dataset.units));
        sum.textContent = parts.join(' · ');
      }
      const img = this.querySelector('.eq-pdp-bar__img');
      if (img && v.image) { img.removeAttribute('srcset'); img.src = v.image; }
      const sels = [...this.querySelectorAll('[data-eq-bar-opt]')];
      sels.forEach((sel) => {
        const hit = [...sel.options].find((o) => v.options.includes(o.value));
        if (hit) sel.value = hit.value;
      });
      /* tamanhos: só os que existem com o sabor selecionado (mesma regra da caixa de compra) */
      const sizes = st.sizeIdx || [];
      const vars = (st.product && st.product.variants) || [];
      if (sizes.length && vars.length && sels.length > 1) {
        const cur = sels.map((s) => s.value);
        sizes.forEach((i) => {
          if (!sels[i]) return;
          [...sels[i].options].forEach((o) => {
            const ok = vars.some((x) => x.options[i] === o.value && cur.every((c, j) => j === i || sizes.includes(j) || x.options[j] === c));
            o.hidden = !ok;
            o.disabled = !ok;
          });
        });
      }
      /* esgotado: "Avise-me" (assets/eq-notify.js) */
      const ntf = !v.available && window.EQ && EQ.notify;
      if (ntf) EQ.notify.set(this.btn, { id: v.id, title: (st.product && st.product.title) || '', variant: v.title, img: v.image, url: location.pathname });
      else if (window.EQ && EQ.notify) EQ.notify.set(this.btn, null);
      this.btn.disabled = !v.available && !ntf;
      const l = this.querySelector('[data-eq-bar-label]');
      if (l) l.textContent = !v.available ? (ntf ? EQ.notify.label(v.id) : this.btn.dataset.soldout) : st.mode === 'sub' ? this.btn.dataset.labelSub : this.btn.dataset.label;
    }
  }
  customElements.define('eq-pdp-bar', EqPdpBar);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-quiz"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__eqQuizBound) return;
  window.__eqQuizBound = true;

  const slug = (t) => String(t || '').replace(/\+/g, ' mais').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  const esc = (t) => String(t).replace(/[&<>"']/g, (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]));
  const num = (v, d) => { const n = parseFloat(String(v == null ? '' : v).replace(',', '.')); return isFinite(n) ? n : d; };
  const fill = (tpl, map) => Object.keys(map).reduce((t, k) => t.split(`[${k}]`).join(map[k]), tpl || '');
  const money = (c) => (window.EQ && EQ.money ? EQ.money(c) : 'R$ ' + (c / 100).toFixed(2).replace('.', ','));
  const store = {
    get(k) { try { return JSON.parse(sessionStorage.getItem(k) || 'null'); } catch (_) { return null; } },
    set(k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (_) {} },
    del(k) { try { sessionStorage.removeItem(k); } catch (_) {} },
  };

  /* tags de uma opção: "objetivo[:peso]", restrição (lista nas configurações), "formato:x", "produto:handle[:peso]", "categoria:x[:peso]", "exclusivo" */
  const parseTags = (str) => String(str || '').split(',').map((t) => t.trim()).filter(Boolean).map((t) => {
    if (t.toLowerCase() === 'exclusivo') return { type: 'exclusive' };
    let m = t.match(/^(formato|produto|categoria):(.+?)(?::(-?\d+(?:[.,]\d+)?))?$/i);
    if (m) return { type: m[1].toLowerCase(), key: slug(m[2]), w: num(m[3], 1) };
    m = t.match(/^(.+?)(?::(-?\d+(?:[.,]\d+)?))?$/);
    return { type: 'key', key: slug(m[1]), w: num(m[2], 1) };
  });

  class Quiz {
    constructor(root) {
      this.root = root;
      this.d = root.dataset;
      this.key = this.d.key;
      this.steps = [...root.querySelectorAll('[data-eq-quiz-step]')];
      this.hasIntro = !root.querySelector('[data-eq-quiz-view="intro"]').hidden;
      this.objEls = [...root.querySelectorAll('[data-eq-quiz-obj]')];
      this.objKeys = this.objEls.map((o) => o.dataset.eqQuizObj);
      this.restrKeys = new Set(String(this.d.restr || '').split(',').map(slug).filter(Boolean));
      this.state = store.get(this.key) || { started: false, step: 0, answers: {}, done: false };
      root.addEventListener('click', (e) => this.onClick(e));
      this.init();
    }
    save() { store.set(this.key, this.state); }
    view(name) {
      this.root.querySelectorAll('[data-eq-quiz-view]').forEach((v) => { v.hidden = v.dataset.eqQuizView !== name; });
    }
    sel(step) { return this.state.answers[step.dataset.id] || []; }
    alias(s) { return this.objKeys.find((k) => k === s || k === 'objetivo-' + s) || s; }
    scrollTop() {
      const r = this.root.getBoundingClientRect();
      if (r.top < 0 || r.top > window.innerHeight * 0.5) window.scrollTo({ top: window.scrollY + r.top - 16, behavior: 'smooth' });
    }

    init() {
      const posted = this.root.querySelector('[data-eq-quiz-posted]');
      if (this.state.done) { this.finish(false); if (posted) setTimeout(() => posted.closest('.eq-quiz__mail').scrollIntoView({ block: 'center' }), 300); return; }
      if (this.state.started || !this.hasIntro) { this.view('run'); this.go(Math.min(this.state.step || 0, this.steps.length - 1), false); return; }
      this.view('intro');
    }

    go(i, focus = true) {
      const N = this.steps.length;
      if (!N) return;
      this.state.step = i;
      this.save();
      this.steps.forEach((s, k) => { s.hidden = k !== i; });
      const step = this.steps[i];
      const chosen = this.sel(step);
      step.querySelectorAll('[data-eq-quiz-opt]').forEach((o) => o.setAttribute('aria-checked', chosen.includes(Number(o.dataset.i)) ? 'true' : 'false'));
      this.root.querySelector('[data-eq-quiz-count]').textContent = fill(this.d.stepText, { n: i + 1, total: N });
      const bar = this.root.querySelector('[data-eq-quiz-bar]');
      bar.setAttribute('aria-valuenow', i + 1);
      bar.firstElementChild.style.width = `${((i + 1) / N) * 100}%`;
      this.root.querySelectorAll('[data-eq-quiz-prev]').forEach((b) => { b.disabled = i === 0 && !this.hasIntro; });
      this.root.querySelector('[data-eq-quiz-next-label]').textContent = i === N - 1 ? this.d.finish : this.d.next;
      this.refreshNext();
      if (focus) { this.scrollTop(); const q = step.querySelector('.eq-quiz__q'); if (q) q.focus({ preventScroll: true }); }
    }
    refreshNext() {
      const step = this.steps[this.state.step];
      if (!step) return;
      const n = this.sel(step).length;
      this.root.querySelector('[data-eq-quiz-next]').disabled = step.dataset.required === 'true' && n === 0;
      const hint = step.querySelector('[data-eq-quiz-hint]');
      if (hint) { const max = Number(step.dataset.max) || 0; hint.textContent = max > 0 ? fill(this.d.multiMax, { max, n }) : this.d.multiAny; }
    }
    pick(opt) {
      const step = opt.closest('[data-eq-quiz-step]');
      const i = Number(opt.dataset.i);
      let cur = this.sel(step).slice();
      if (step.dataset.multi !== 'true') {
        cur = [i];
      } else if (cur.includes(i)) {
        cur = cur.filter((x) => x !== i);
      } else {
        const opts = [...step.querySelectorAll('[data-eq-quiz-opt]')];
        const isEx = (n) => { const o = opts.find((x) => Number(x.dataset.i) === n); return o && parseTags(o.dataset.tags).some((t) => t.type === 'exclusive'); };
        if (isEx(i)) cur = [];
        else cur = cur.filter((x) => !isEx(x));
        const max = Number(step.dataset.max) || 0;
        if (max > 0 && cur.length >= max) {
          const hint = step.querySelector('[data-eq-quiz-hint]');
          if (hint) { hint.classList.remove('is-shake'); void hint.offsetWidth; hint.classList.add('is-shake'); }
          return;
        }
        cur.push(i);
      }
      this.state.answers[step.dataset.id] = cur;
      this.state.started = true;
      this.save();
      step.querySelectorAll('[data-eq-quiz-opt]').forEach((o) => o.setAttribute('aria-checked', cur.includes(Number(o.dataset.i)) ? 'true' : 'false'));
      this.refreshNext();
      if (step.dataset.multi !== 'true' && this.d.auto === 'true' && cur.length) {
        clearTimeout(this.t);
        this.t = setTimeout(() => this.next(), 320);
      }
    }
    next() {
      const step = this.steps[this.state.step];
      if (step && step.dataset.required === 'true' && !this.sel(step).length) return;
      if (this.state.step < this.steps.length - 1) this.go(this.state.step + 1);
      else this.finish(true);
    }
    prev() {
      if (this.state.step > 0) this.go(this.state.step - 1);
      else if (this.hasIntro) { this.state.started = false; this.save(); this.view('intro'); this.scrollTop(); }
    }

    /* ---------- perfil e pontuação ---------- */
    profile() {
      const p = { obj: {}, restr: new Set(), fmt: new Set(), prod: {}, cat: {}, keys: new Set() };
      this.steps.forEach((step) => {
        const chosen = this.sel(step);
        step.querySelectorAll('[data-eq-quiz-opt]').forEach((o) => {
          if (!chosen.includes(Number(o.dataset.i))) return;
          parseTags(o.dataset.tags).forEach((t) => {
            if (t.type === 'exclusive') return;
            if (t.type === 'formato') p.fmt.add(t.key);
            else if (t.type === 'produto') p.prod[t.key] = (p.prod[t.key] || 0) + t.w;
            else if (t.type === 'categoria') p.cat[t.key] = (p.cat[t.key] || 0) + t.w;
            else if (this.restrKeys.has(t.key)) p.restr.add(t.key);
            else { const k = this.alias(t.key); p.obj[k] = (p.obj[k] || 0) + t.w; p.keys.add(k); }
          });
        });
      });
      const min = num(this.d.objMin, 1);
      p.top = this.objKeys.filter((k) => (p.obj[k] || 0) >= min).sort((a, b) => (p.obj[b] - p.obj[a]) || (this.objKeys.indexOf(a) - this.objKeys.indexOf(b))).slice(0, 2);
      return p;
    }
    scoreProduct(li, p) {
      if (li.dataset.available !== 'true') return null;
      const pobj = String(li.dataset.obj || '').split('|').filter(Boolean).map((x) => this.alias(slug(x)));
      const prestr = new Set(String(li.dataset.restr || '').split('|').filter(Boolean).map(slug));
      let score = pobj.reduce((a, k) => a + (p.obj[k] || 0), 0);
      score += String(li.dataset.cat || '').split('|').filter(Boolean).reduce((a, c) => a + (p.cat[slug(c)] || 0), 0);
      score += p.prod[li.dataset.handle] || 0;
      if (score <= 0) return null;
      const missing = [...p.restr].filter((r) => !prestr.has(r));
      if (missing.length) { if (this.d.strict === 'true') return null; score -= 3 * missing.length; }
      if (p.fmt.size) score += p.fmt.has(slug(li.dataset.format)) ? num(this.d.fmtBonus, 2) : -1;
      if (p.top[0] && pobj.includes(p.top[0])) score += 1;
      if (li.dataset.best === '1') score += 0.5;
      return { li, score, pobj, prestr };
    }
    finish(scroll) {
      const p = this.profile();
      const root = this.root;
      this.state.done = true;
      this.save();

      /* objetivos */
      const titles = p.top.map((k) => { const o = this.objEls.find((x) => x.dataset.eqQuizObj === k); return o ? o.dataset.title : k; });
      const tpl = titles.length > 1 ? this.d.title2 : titles.length ? this.d.title1 : this.d.title0;
      root.querySelector('[data-eq-quiz-headline]').innerHTML = esc(fill(tpl, { objetivo: '\u0001', objetivo2: '\u0002' })).replace('\u0001', `<em>${esc(titles[0] || '')}</em>`).replace('\u0002', `<em>${esc(titles[1] || '')}</em>`);
      const wrap = root.querySelector('[data-eq-quiz-objs]');
      this.objEls.forEach((o) => { o.hidden = true; });
      p.top.forEach((k, idx) => {
        const o = this.objEls.find((x) => x.dataset.eqQuizObj === k);
        if (!o) return;
        o.hidden = false;
        o.querySelector('[data-eq-quiz-rank]').textContent = idx === 0 ? this.d.rank1 : this.d.rank2;
        wrap.appendChild(o);
      });

      /* respostas */
      const dl = root.querySelector('[data-eq-quiz-answers]');
      dl.innerHTML = this.steps.map((step) => {
        const chosen = this.sel(step);
        const labels = [...step.querySelectorAll('[data-eq-quiz-opt]')].filter((o) => chosen.includes(Number(o.dataset.i))).map((o) => o.querySelector('.eq-quiz__opt-label').textContent.trim());
        return `<div><dt>${esc(step.dataset.label)}</dt><dd>${esc(labels.join(', ') || this.d.none)}</dd></div>`;
      }).join('');

      /* produtos */
      const grid = root.querySelector('[data-eq-quiz-grid]');
      const all = [...root.querySelectorAll('[data-eq-quiz-product]')];
      const scored = all.map((li) => this.scoreProduct(li, p)).filter(Boolean);
      const limit = Number(this.d.limit) || 4;
      const picks = [];
      const used = {};
      while (picks.length < limit && scored.length) {
        let bi = 0, bs = -Infinity;
        scored.forEach((x, i) => { const adj = x.score * Math.pow(0.5, used[x.li.dataset.group] || 0); if (adj > bs) { bs = adj; bi = i; } });
        const x = scored.splice(bi, 1)[0];
        used[x.li.dataset.group] = (used[x.li.dataset.group] || 0) + 1;
        picks.push(x);
      }
      all.forEach((li) => { li.hidden = true; });
      const restrLabel = {};
      all.forEach((li) => String(li.dataset.restr || '').split('|').filter(Boolean).forEach((r) => { restrLabel[slug(r)] = r; }));
      picks.forEach((x) => {
        x.li.hidden = false;
        grid.appendChild(x.li);
        const objs = x.pobj.filter((k) => p.obj[k] > 0).sort((a, b) => p.obj[b] - p.obj[a]).slice(0, 2)
          .map((k) => { const o = this.objEls.find((e) => e.dataset.eqQuizObj === k); return o ? o.dataset.title : null; }).filter(Boolean);
        const why = x.li.querySelector('[data-eq-quiz-why]');
        why.innerHTML = objs.map((t) => `<span>${esc(fill(this.d.why, { objetivo: t }))}</span>`).join('')
          + [...p.restr].filter((r) => x.prestr.has(r)).map((r) => `<span class="is-restr">${esc(restrLabel[r] || r)}</span>`).join('');
      });
      root.querySelector('[data-eq-quiz-empty]').hidden = picks.length > 0;
      const items = picks.map((x) => ({ id: Number(x.li.dataset.variant), quantity: 1 }));
      const total = picks.reduce((a, x) => a + Number(x.li.dataset.price || 0), 0);
      root.querySelectorAll('[data-eq-quiz-addall]').forEach((b) => {
        b.hidden = picks.length < 2;
        b.dataset.eqItems = JSON.stringify(items);
        const l = b.querySelector('[data-eq-quiz-addall-label]');
        if (l) l.textContent = fill(this.d.addAll, { n: picks.length, total: money(total) });
      });

      /* kit */
      const kitsBox = root.querySelector('[data-eq-quiz-kits]');
      if (kitsBox) {
        const byHandle = {};
        all.forEach((li) => { byHandle[li.dataset.handle] = li; });
        let best = null;
        kitsBox.querySelectorAll('[data-eq-quiz-kit]').forEach((k) => {
          k.hidden = true;
          if (k.dataset.available !== 'true') return;
          const kobj = String(k.dataset.obj || '').split('|').filter(Boolean).map((x) => this.alias(slug(x)));
          const boost = p.prod[k.dataset.handle] || 0;
          if (!(p.top[0] && kobj.includes(p.top[0])) && boost <= 0) return;
          if (p.restr.size && this.d.strict === 'true') {
            const comps = String(k.dataset.items || '').split('|').filter(Boolean);
            const ok = comps.length && comps.every((h) => { const li = byHandle[h]; const rs = li ? String(li.dataset.restr || '').split('|').map(slug) : []; return [...p.restr].every((r) => rs.includes(r)); });
            if (!ok) return;
          }
          const sc = kobj.reduce((a, o) => a + (p.obj[o] || 0), 0) + boost;
          if (!best || sc > best.sc) best = { k, sc };
        });
        kitsBox.hidden = !best;
        if (best) best.k.hidden = false;
      }

      /* calculadoras e e-mail */
      let anyCalc = false;
      root.querySelectorAll('[data-eq-quiz-calc]').forEach((c) => {
        const want = String(c.dataset.show || '').split(',').map(slug).filter(Boolean);
        const on = !want.length || want.some((t) => (p.obj[this.alias(t)] || 0) > 0 || p.keys.has(t) || p.restr.has(t));
        c.hidden = !on;
        if (on) anyCalc = true;
      });
      const nx = root.querySelector('[data-eq-quiz-next-steps]');
      if (nx) nx.hidden = !anyCalc && !root.querySelector('.eq-quiz__mail');
      const tags = root.querySelector('[data-eq-quiz-tags]');
      if (tags) tags.value = ['quiz'].concat(p.top).join(',');

      this.view('result');
      if (scroll) { this.scrollTop(); root.querySelector('[data-eq-quiz-view="result"]').focus({ preventScroll: true }); }
    }
    restart() {
      this.state = { started: false, step: 0, answers: {}, done: false };
      this.save();
      if (this.hasIntro) this.view('intro'); else { this.view('run'); this.go(0, false); }
      this.scrollTop();
    }
    onClick(e) {
      const t = e.target.closest('[data-eq-quiz-opt],[data-eq-quiz-start],[data-eq-quiz-next],[data-eq-quiz-prev],[data-eq-quiz-edit],[data-eq-quiz-restart]');
      if (!t || !this.root.contains(t)) return;
      if (t.matches('[data-eq-quiz-opt]')) return this.pick(t);
      if (t.matches('[data-eq-quiz-start]')) { this.state.started = true; this.view('run'); return this.go(0); }
      if (t.matches('[data-eq-quiz-next]')) return this.next();
      if (t.matches('[data-eq-quiz-prev]')) return this.prev();
      if (t.matches('[data-eq-quiz-edit]')) { this.state.done = false; this.state.started = true; this.view('run'); return this.go(0); }
      if (t.matches('[data-eq-quiz-restart]')) return this.restart();
    }
  }

  const boot = (scope) => (scope || document).querySelectorAll('[data-eq-quiz]').forEach((r) => { if (!r.__eqQuiz) r.__eqQuiz = new Quiz(r); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot()); else boot();
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
  document.addEventListener('shopify:block:select', (e) => {
    const el = e.target;
    const root = el.closest && el.closest('[data-eq-quiz]');
    if (!root || !root.__eqQuiz) return;
    const q = root.__eqQuiz;
    if (el.matches('[data-eq-quiz-step]')) { q.view('run'); q.go(q.steps.indexOf(el), false); }
    else if (el.matches('[data-eq-quiz-obj]')) { q.finish(false); el.hidden = false; }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-recipe-body"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__eqRingr) return;
  window.__eqRingr = true;
  const FR = { '½': 0.5, '¼': 0.25, '¾': 0.75, '⅓': 1 / 3, '⅔': 2 / 3 };
  const parse = (q) => {
    q = q.trim();
    let m;
    if ((m = q.match(/^(\d+)\s+([½¼¾⅓⅔])$/))) return Number(m[1]) + FR[m[2]];
    if (FR[q] != null) return FR[q];
    if ((m = q.match(/^(\d+)\/(\d+)$/))) return Number(m[1]) / Number(m[2]);
    return Number(q.replace(',', '.'));
  };
  const fmt = (n) => {
    const r = Math.round(n * 4) / 4;
    const whole = Math.floor(r), frac = r - whole;
    const sym = frac === 0.5 ? '½' : frac === 0.25 ? '¼' : frac === 0.75 ? '¾' : '';
    if (Math.abs(n - r) < 0.08 && (sym || frac === 0)) return whole === 0 ? sym || '0' : whole + (sym ? ' ' + sym : '');
    return (Math.round(n * 10) / 10).toLocaleString('pt-BR');
  };
  const fmtUnit = (n) => (n >= 10 ? String(Math.round(n)) : (Math.round(n * 10) / 10).toLocaleString('pt-BR'));
  const scale = (txt, k) => {
    let out = txt.replace(/^(\d+\s+[½¼¾⅓⅔]|\d+\/\d+|\d+[.,]\d+|\d+|[½¼¾⅓⅔])(?=\s|$)/, (q) => fmt(parse(q) * k));
    out = out.replace(/\((\d+(?:[.,]\d+)?)\s*(g|ml|kg|l)\b/gi, (all, q, u) => `(${fmtUnit(parse(q) * k)} ${u}`);
    return out;
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest && e.target.closest('[data-eq-ringr-step]');
    if (!b) return;
    const root = b.closest('[data-eq-ringr]');
    const base = Number(root.dataset.base) || 1;
    const el = root.querySelector('[data-eq-ringr-n]');
    const n = Math.max(1, Math.min(base * 10, Number(el.textContent) + Number(b.dataset.eqRingrStep)));
    el.textContent = n;
    root.querySelector('[data-eq-ringr-step="-1"]').disabled = n <= 1;
    const k = n / base;
    root.querySelectorAll('[data-eq-ringr-txt]').forEach((t) => (t.textContent = k === 1 ? t.dataset.orig : scale(t.dataset.orig, k)));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-recipe-grid"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__eqRgrid) return;
  window.__eqRgrid = true;
  const mq = window.matchMedia('(max-width: 989px)');
  const fill = (t, m) => Object.keys(m).reduce((s, k) => s.split(`[${k}]`).join(m[k]), t || '');
  const norm = (t) => String(t || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
  class Grid {
    constructor(root) {
      this.root = root;
      this.d = root.dataset;
      this.cells = [...root.querySelectorAll('[data-eq-rgrid-cell]')];
      try { this.names = JSON.parse(root.querySelector('[data-eq-rgrid-names]').textContent || '{}'); } catch (_) { this.names = {}; }
      const p = new URLSearchParams(location.search);
      this.st = { cat: p.get('categoria') || '', prod: p.get('produto') || '', q: p.get('q') || '', page: 1, per: Number(this.d.per) || 8, shown: Number(this.d.perM) || 4 };
      root.addEventListener('click', (e) => this.onClick(e));
      const sel = root.querySelector('[data-eq-rgrid-per]');
      if (sel) sel.addEventListener('change', () => { this.st.per = Number(sel.value) || 8; this.st.page = 1; this.render(); });
      document.addEventListener('eq:recipes:set', (e) => {
        const d = e.detail || {};
        if ('prod' in d) this.st.prod = d.prod || '';
        if ('cat' in d) this.st.cat = d.cat || '';
        if (d.prodName && d.prod) this.names[d.prod] = d.prodName;
        this.st.page = 1; this.st.shown = Number(this.d.perM) || 4;
        this.render(true);
        if (d.scroll) this.root.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      });
      document.addEventListener('eq:cont:search', (e) => {
        const d = e.detail || {};
        if (d.scope && d.scope !== 'recipes') return;
        this.st.q = d.q || ''; this.st.page = 1; this.render(true);
      });
      mq.addEventListener('change', () => this.render());
      this.render(false);
      setTimeout(() => this.emit(), 0);
    }
    onClick(e) {
      const chip = e.target.closest('[data-eq-rgrid-cat]');
      if (chip) { this.st.cat = chip.dataset.eqRgridCat; this.st.page = 1; this.st.shown = Number(this.d.perM) || 4; this.render(true); return; }
      const pg = e.target.closest('[data-eq-rgrid-page]');
      if (pg) {
        const v = pg.dataset.eqRgridPage;
        this.st.page = v === 'prev' ? this.st.page - 1 : v === 'next' ? this.st.page + 1 : Number(v);
        this.render(true);
        this.root.scrollIntoView({ block: 'start' });
        return;
      }
      if (e.target.closest('[data-eq-rgrid-more]')) { this.st.shown += Number(this.d.perM) || 4; this.render(); return; }
      if (e.target.closest('[data-eq-rgrid-clear]')) {
        this.st.cat = ''; this.st.prod = ''; this.st.q = ''; this.st.page = 1;
        const inp = document.querySelector('[data-eq-cont-search] input[type=search]');
        if (inp) inp.value = '';
        this.render(true);
      }
    }
    match(c) {
      const card = c.firstElementChild;
      const st = this.st;
      if (st.cat && !(card.dataset.cats || '').includes('|' + st.cat + '|')) return false;
      if (st.prod && !(card.dataset.prods || '').includes('|' + st.prod + '|')) return false;
      if (st.q) {
        const words = norm(st.q).split(/\s+/).filter(Boolean);
        const hay = norm(card.dataset.search);
        if (!words.every((w) => hay.includes(w))) return false;
      }
      return true;
    }
    render(push) {
      const st = this.st;
      const list = this.cells.filter((c) => this.match(c));
      const total = list.length;
      const videos = list.filter((c) => c.firstElementChild.dataset.video).length;
      const pages = Math.max(1, Math.ceil(total / st.per));
      st.page = Math.min(Math.max(1, st.page), pages);
      const mobile = mq.matches;
      const from = mobile ? 0 : (st.page - 1) * st.per;
      const to = mobile ? st.shown : from + st.per;
      this.cells.forEach((c) => (c.hidden = true));
      list.forEach((c, i) => (c.hidden = !(i >= from && i < to)));
      /* título e contagem */
      const t = this.root.querySelector('[data-eq-rgrid-title]');
      const name = st.prod ? this.names[st.prod] || '' : '';
      if (t) t.textContent = st.prod && name && this.d.titleProd ? fill(this.d.titleProd, { produto: name }) : this.d.title;
      const cnt = this.root.querySelector('[data-eq-rgrid-count]');
      if (cnt) {
        let txt = fill(total === 1 ? this.d.countOne : this.d.count, { n: total });
        if ((st.prod || st.cat) && videos > 0) txt += ' • ' + fill(videos === 1 ? this.d.countVideoOne : this.d.countVideos, { n: videos });
        cnt.textContent = txt;
      }
      this.root.querySelectorAll('[data-eq-rgrid-cat]').forEach((c) => c.setAttribute('aria-pressed', c.dataset.eqRgridCat === st.cat ? 'true' : 'false'));
      const of = this.root.querySelector('[data-eq-rgrid-of]');
      if (of) of.textContent = fill(this.d.showing, { n: total });
      /* vazio, paginação, ver mais */
      this.root.querySelector('[data-eq-rgrid-empty]').hidden = total > 0;
      const foot = this.root.querySelector('[data-eq-rgrid-foot]');
      foot.hidden = total === 0;
      const more = this.root.querySelector('[data-eq-rgrid-more]');
      if (more) more.hidden = st.shown >= total;
      const pager = this.root.querySelector('[data-eq-rgrid-pager]');
      if (pager) {
        pager.style.visibility = pages > 1 ? '' : 'hidden';
        pager.querySelector('[data-eq-rgrid-page="prev"]').disabled = st.page <= 1;
        pager.querySelector('[data-eq-rgrid-page="next"]').disabled = st.page >= pages;
        const nums = pager.querySelector('[data-eq-rgrid-nums]');
        const arr = [];
        for (let i = 1; i <= pages; i++) if (i === 1 || i === pages || Math.abs(i - st.page) <= 1 || pages <= 5) arr.push(i); else if (arr[arr.length - 1] !== '…') arr.push('…');
        nums.innerHTML = arr.map((n) => (n === '…' ? '<span class="eq-pager__gap">…</span>' : `<button type="button" class="eq-pager__num" data-eq-rgrid-page="${n}"${n === st.page ? ' aria-current="page"' : ''} aria-label="Página ${n}">${n}</button>`)).join('');
      }
      if (push) {
        const u = new URL(location.href);
        st.prod ? u.searchParams.set('produto', st.prod) : u.searchParams.delete('produto');
        st.cat ? u.searchParams.set('categoria', st.cat) : u.searchParams.delete('categoria');
        history.replaceState(history.state, '', u.toString());
        this.emit(total, videos);
      }
    }
    emit(total, videos) {
      document.dispatchEvent(new CustomEvent('eq:recipes:filter', { detail: { prod: this.st.prod, cat: this.st.cat, q: this.st.q, total, videos } }));
    }
  }
  const init = () => document.querySelectorAll('[data-eq-rgrid]').forEach((r) => { if (!r.dataset.ready) { r.dataset.ready = '1'; new Grid(r); } });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-recipe-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__eqRhero) return;
  window.__eqRhero = true;
  document.addEventListener('click', async (e) => {
    const b = e.target.closest && e.target.closest('[data-eq-rhero-act]');
    if (!b) return;
    const act = b.dataset.eqRheroAct;
    const url = location.origin + location.pathname;
    if (act === 'print') { window.print(); return; }
    if (act === 'share' && navigator.share) { try { await navigator.share({ title: b.dataset.title, url }); } catch (_) {} return; }
    try { await navigator.clipboard.writeText(url); if (window.EQ) EQ.toast('Link da receita copiado'); } catch (_) {}
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-recipe-madewith"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__eqRkit) return;
  window.__eqRkit = true;
  const money = (c) => (window.EQ ? EQ.money(c) : 'R$ ' + (c / 100).toFixed(2).replace('.', ','));
  const sel = (item) => {
    const v = item.querySelector('[data-eq-rkit-var]');
    const o = v.tagName === 'SELECT' ? v.selectedOptions[0] : v;
    return { id: Number(v.value), price: Number(o.dataset.price) || 0, compare: Number(o.dataset.compare) || 0 };
  };
  const paint = (root) => {
    let tot = 0, cmp = 0, n = 0;
    root.querySelectorAll('[data-eq-rkit-item]').forEach((it) => {
      const s = sel(it);
      it.querySelector('[data-eq-rkit-price]').textContent = money(s.price);
      if (!it.querySelector('[data-eq-rkit-on]').checked) return;
      n++; tot += s.price; cmp += Math.max(s.compare, s.price);
    });
    root.querySelector('[data-eq-rkit-total]').textContent = money(tot);
    const c = root.querySelector('[data-eq-rkit-compare]');
    c.hidden = !(cmp > tot); c.textContent = money(cmp);
    root.querySelector('[data-eq-rkit-add]').disabled = n === 0;
  };
  const init = () => document.querySelectorAll('[data-eq-rkit]').forEach((r) => { if (!r.dataset.ready) { r.dataset.ready = '1'; paint(r); } });
  document.addEventListener('change', (e) => { const r = e.target.closest && e.target.closest('[data-eq-rkit]'); if (r) paint(r); });
  document.addEventListener('click', async (e) => {
    const b = e.target.closest && e.target.closest('[data-eq-rkit-add]');
    if (!b) return;
    const r = b.closest('[data-eq-rkit]');
    const items = [...r.querySelectorAll('[data-eq-rkit-item]')].filter((it) => it.querySelector('[data-eq-rkit-on]').checked).map((it) => ({ id: sel(it).id, quantity: 1, properties: { _kit: r.dataset.kit } }));
    if (!items.length) { if (window.EQ) EQ.toast(r.dataset.errnone); return; }
    b.classList.add('is-loading'); b.disabled = true;
    try { await EQ.cart.add(items); } catch (err) { EQ.toast(err.message); }
    b.classList.remove('is-loading'); b.disabled = false;
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-recipe-products"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__eqRprod) return;
  window.__eqRprod = true;
  document.addEventListener('click', (e) => {
    const b = e.target.closest && e.target.closest('[data-eq-rprod]');
    if (!b) return;
    const on = b.getAttribute('aria-pressed') !== 'true';
    document.dispatchEvent(new CustomEvent('eq:recipes:set', { detail: { prod: on ? b.dataset.eqRprod : '', prodName: on ? b.dataset.name : '', scroll: true } }));
  });
  document.addEventListener('eq:recipes:filter', (e) => {
    const prod = (e.detail && e.detail.prod) || '';
    document.querySelectorAll('[data-eq-rprod-root]').forEach((root) => {
      root.classList.toggle('is-filtering', !!prod);
      root.querySelectorAll('[data-eq-rprod]').forEach((b) => b.setAttribute('aria-pressed', b.dataset.eqRprod === prod ? 'true' : 'false'));
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-recipe-reels"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__eqReels2) return;
  window.__eqReels2 = true;
  document.addEventListener('eq:recipes:filter', (e) => {
    const on = !!(e.detail && (e.detail.prod || e.detail.cat || e.detail.q));
    document.querySelectorAll('[data-eq-reels-hide]').forEach((s) => (s.hidden = on));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-recipe-shorts"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__eqShorts) return;
  window.__eqShorts = true;
  const fill = (t, m) => Object.keys(m).reduce((s, k) => s.split(`[${k}]`).join(m[k]), t || '');
  const P = {
    root: null, items: [], i: 0, lastFocus: null,
    init() {
      this.root = document.querySelector('[data-eq-shorts]');
      if (!this.root) return false;
      if (this.root.parentElement !== document.body) document.body.appendChild(this.root);
      try { this.items = JSON.parse(this.root.querySelector('[data-eq-shorts-data]').textContent); } catch (_) { this.items = []; }
      if (this.bound) return true;
      this.bound = true;
      const r = this.root;
      r.addEventListener('click', (e) => this.onClick(e));
      r.addEventListener('keydown', (e) => this.onKey(e));
      r.addEventListener('wheel', (e) => { if (Math.abs(e.deltaY) < 30 || this.wheelLock) return; this.wheelLock = true; setTimeout(() => (this.wheelLock = false), 600); this.go(e.deltaY > 0 ? 1 : -1); }, { passive: true });
      const fr = r.querySelector('[data-eq-shorts-frame]');
      let y0 = null, t0 = 0;
      fr.addEventListener('pointerdown', (e) => { if (e.pointerType === 'mouse') return; y0 = e.clientY; t0 = Date.now(); });
      fr.addEventListener('pointerup', (e) => { if (y0 == null) return; const dy = e.clientY - y0; const v = Math.abs(dy) / Math.max(1, Date.now() - t0); y0 = null; if (Math.abs(dy) > 60 || v > 0.5) this.go(dy < 0 ? 1 : -1); });
      fr.addEventListener('pointercancel', () => (y0 = null));
      fr.addEventListener('touchmove', (e) => { if (y0 != null) e.preventDefault(); }, { passive: false });
      return true;
    },
    open(handle) {
      if (!this.init() || !this.items.length) return false;
      let i = this.items.findIndex((x) => x.h === handle);
      if (i < 0) i = 0;
      this.lastFocus = document.activeElement;
      this.root.hidden = false;
      document.documentElement.classList.add('eq-lock');
      this.show(i);
      this.root.querySelector('.eq-shorts__close').focus({ preventScroll: true });
      return true;
    },
    close() {
      if (!this.root || this.root.hidden) return;
      this.stop();
      this.root.hidden = true;
      document.documentElement.classList.remove('eq-lock');
      if (location.hash.startsWith('#shorts=')) history.replaceState(history.state, '', location.pathname + location.search);
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
    },
    stop() { const v = this.root && this.root.querySelector('[data-eq-shorts-media] video'); if (v) v.pause(); },
    go(d) { const n = this.i + d; if (n < 0 || n >= this.items.length) return; this.show(n); },
    show(i) {
      const r = this.root, it = this.items[i], d = r.dataset;
      this.i = i;
      const media = r.querySelector('[data-eq-shorts-media]');
      this.stop();
      media.innerHTML = '';
      const bar = r.querySelector('[data-eq-shorts-bar]');
      const tog = r.querySelector('[data-eq-shorts-toggle]');
      const mute = r.querySelector('[data-eq-shorts-mute]');
      bar.firstElementChild.style.width = '0';
      if (it.cover) { const im = new Image(); im.src = it.cover; im.alt = ''; media.appendChild(im); }
      if (it.src) {
        const v = document.createElement('video');
        Object.assign(v, { src: it.src, muted: mute.getAttribute('aria-pressed') === 'true', loop: true, playsInline: true, autoplay: !matchMedia('(prefers-reduced-motion: reduce)').matches, poster: it.cover || '' });
        v.setAttribute('playsinline', '');
        v.addEventListener('timeupdate', () => { if (v.duration) bar.firstElementChild.style.width = (v.currentTime / v.duration) * 100 + '%'; });
        v.addEventListener('click', () => (v.paused ? v.play() : v.pause()));
        media.appendChild(v);
        v.play().catch(() => {});
        bar.hidden = false; tog.hidden = false; mute.hidden = false;
      } else if (it.yt) {
        const f = document.createElement('iframe');
        f.src = `https://www.youtube-nocookie.com/embed/${it.yt}?autoplay=1&mute=1&playsinline=1&loop=1&playlist=${it.yt}&controls=0&rel=0`;
        f.allow = 'autoplay; encrypted-media; picture-in-picture';
        f.title = it.t;
        media.appendChild(f);
        bar.hidden = true; tog.hidden = true; mute.hidden = true;
      } else { bar.hidden = true; tog.hidden = true; mute.hidden = true; }
      r.querySelector('[data-eq-shorts-title]').textContent = it.t;
      r.querySelector('[data-eq-shorts-meta]').textContent = it.meta || '';
      r.querySelector('[data-eq-shorts-recipe]').href = it.url;
      /* produto */
      const box = r.querySelector('[data-eq-shorts-prod]');
      const fav = r.querySelector('[data-eq-shorts-fav]');
      if (it.p) {
        box.hidden = false;
        const many = it.p.n > 1;
        r.querySelector('[data-eq-shorts-pname]').textContent = many ? fill(d.feitoN, { n: it.p.n }) : fill(d.feito, { produto: it.p.t });
        r.querySelector('[data-eq-shorts-pprice]').textContent = many ? '' : it.p.price;
        const pim = r.querySelector('[data-eq-shorts-pimg]');
        pim.src = it.p.img || 'data:,';
        const add = r.querySelector('[data-eq-shorts-add]');
        const kit = r.querySelector('[data-eq-shorts-kit]');
        const ntf = !it.p.avail && !!(window.EQ && EQ.notify);
        add.hidden = many || (!it.p.avail && !ntf); kit.hidden = !many && (it.p.avail || ntf);
        kit.href = it.url + '#feito-com';
        add.dataset.variant = it.p.v; add.dataset.handle = it.p.handle; add.dataset.multi = it.p.multi ? '1' : '';
        /* esgotado: avise-me (várias variantes → quick add, que oferece o avise-me por variante) */
        if (window.EQ && EQ.notify) {
          EQ.notify.set(add, ntf && !it.p.multi ? { id: it.p.v, title: it.p.t, img: it.p.img, url: '/products/' + it.p.handle } : null);
          add.classList.toggle('is-notify', ntf);
          if (ntf) add.setAttribute('aria-label', EQ.notify.label(it.p.v) + ': ' + it.p.t);
          else add.setAttribute('aria-label', add.dataset.addLabel || add.getAttribute('aria-label'));
        }
        fav.hidden = false;
        fav.dataset.eqFav = it.p.id;
        fav.setAttribute('aria-pressed', window.EQ && EQ.favs && EQ.favs.has(it.p.id) ? 'true' : 'false');
      } else { box.hidden = true; fav.hidden = true; delete fav.dataset.eqFav; }
      /* navegação */
      r.querySelectorAll('[data-eq-shorts-go="-1"]').forEach((b) => (b.disabled = i === 0));
      r.querySelectorAll('.eq-shorts__navbtn[data-eq-shorts-go="1"]').forEach((b) => (b.disabled = i >= this.items.length - 1));
      const nx = this.items[i + 1];
      const nb = r.querySelector('[data-eq-shorts-nextbox]');
      nb.hidden = !nx;
      if (nx) {
        r.querySelector('[data-eq-shorts-nimg]').src = nx.thumb || nx.cover || 'data:,';
        r.querySelector('[data-eq-shorts-ntitle]').textContent = nx.t;
        r.querySelector('[data-eq-shorts-nmeta]').textContent = nx.short || '';
      }
      r.querySelector('[data-eq-shorts-live]').textContent = `${it.t} (${i + 1}/${this.items.length})`;
      history.replaceState(history.state, '', location.pathname + location.search + '#shorts=' + it.h);
    },
    async onClick(e) {
      const t = e.target;
      if (t.closest('[data-eq-shorts-close]')) { this.close(); return; }
      const g = t.closest('[data-eq-shorts-go]');
      if (g) { this.go(Number(g.dataset.eqShortsGo)); return; }
      const tog = t.closest('[data-eq-shorts-toggle]');
      const v = this.root.querySelector('[data-eq-shorts-media] video');
      if (tog && v) { v.paused ? v.play() : v.pause(); tog.setAttribute('aria-label', v.paused ? 'Reproduzir' : 'Pausar'); return; }
      const m = t.closest('[data-eq-shorts-mute]');
      if (m) { const on = m.getAttribute('aria-pressed') !== 'true'; m.setAttribute('aria-pressed', on ? 'true' : 'false'); if (v) v.muted = on; return; }
      const add = t.closest('[data-eq-shorts-add]');
      if (add) {
        if (add.dataset.multi && window.EQ && EQ.quickAdd) { this.close(); EQ.quickAdd(add.dataset.handle); return; }
        add.classList.add('is-loading');
        try { await EQ.cart.add([{ id: Number(add.dataset.variant), quantity: 1 }], { open: false }); EQ.toast(EQ.settings.addedText || 'Adicionado à sacola'); } catch (err) { EQ.toast(err.message); }
        add.classList.remove('is-loading');
        return;
      }
      const it = this.items[this.i];
      const url = new URL(it.url, location.origin).toString();
      if (t.closest('[data-eq-shorts-save]')) { try { await navigator.clipboard.writeText(url); } catch (_) {} if (window.EQ) EQ.toast(this.root.dataset.copied); return; }
      if (t.closest('[data-eq-shorts-share]')) {
        if (navigator.share) { try { await navigator.share({ title: it.t, url }); } catch (_) {} }
        else { try { await navigator.clipboard.writeText(url); } catch (_) {} if (window.EQ) EQ.toast(this.root.dataset.copied); }
      }
    },
    onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); this.close(); return; }
      if (e.key === 'ArrowDown' || e.key === 'PageDown') { e.preventDefault(); this.go(1); return; }
      if (e.key === 'ArrowUp' || e.key === 'PageUp') { e.preventDefault(); this.go(-1); return; }
      if (e.key === 'Tab') {
        const f = [...this.root.querySelectorAll('button, a[href]')].filter((x) => !x.hidden && !x.closest('[hidden]') && !x.disabled && x.offsetParent);
        if (!f.length) return;
        const first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    },
  };
  window.EQ_SHORTS = P;
  document.addEventListener('click', (e) => {
    const o = e.target.closest && e.target.closest('[data-eq-shorts-open]');
    if (!o) return;
    if (P.open(o.dataset.eqShortsOpen)) e.preventDefault();
  });
  const fromHash = () => { if (location.hash.startsWith('#shorts=')) P.open(decodeURIComponent(location.hash.slice(8))); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fromHash); else fromHash();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-recipe-videos"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__eqRvid) return;
  window.__eqRvid = true;
  document.addEventListener('eq:recipes:filter', (e) => {
    const prod = (e.detail && e.detail.prod) || '';
    document.querySelectorAll('[data-eq-rvid]').forEach((root) => {
      let n = 0;
      root.querySelectorAll('.eq-rvcard').forEach((c) => {
        const on = !prod || (c.dataset.prods || '').includes('|' + prod + '|');
        c.hidden = !on;
        if (on) n++;
      });
      root.classList.toggle('is-filtered', !!prod);
      root.hidden = n === 0;
      const car = root.querySelector('eq-carousel');
      if (car && car.build) car.build();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-search-articles"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.EQ_SART) return;
  window.EQ_SART = 1;
  const reveal = (root, more) => {
    const items = [...root.querySelectorAll('[data-eq-sart-items] > li')];
    const per = Number(root.dataset.per) || 8;
    const shown = more ? (Number(root.dataset.shown) || per) + per : Number(root.dataset.shown) || per;
    root.dataset.shown = shown;
    items.forEach((li, i) => (li.hidden = i >= shown));
    root.dataset.complete = shown >= items.length ? '1' : '';
  };
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-eq-sart-more]');
    if (!btn) return;
    const root = btn.closest('[data-eq-sart]');
    if (!root || root.dataset.complete === '1') return;
    e.preventDefault();
    reveal(root, true);
  });
  document.addEventListener('change', (e) => {
    const sel = e.target.closest && e.target.closest('[data-eq-sart-sort]');
    if (!sel) return;
    const root = sel.closest('[data-eq-sart]');
    const list = root.querySelector('[data-eq-sart-items]');
    const items = [...list.children];
    items.sort((a, b) => {
      if (sel.value === 'date-desc') return Number(b.dataset.d) - Number(a.dataset.d);
      if (sel.value === 'title-asc') return a.dataset.t.localeCompare(b.dataset.t, 'pt-BR');
      return Number(a.dataset.i) - Number(b.dataset.i);
    });
    items.forEach((li) => list.appendChild(li));
    reveal(root);
  });
  const boot = () => document.querySelectorAll('[data-eq-sart]').forEach((r) => reveal(r));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-search-head"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.EQ_SHEAD) return;
  window.EQ_SHEAD = 1;
  const KEY = 'eq:search:recent';
  const remember = (t) => {
    t = (t || '').trim();
    if (!t) return;
    try {
      const list = (JSON.parse(localStorage.getItem(KEY)) || []).filter((x) => x.toLowerCase() !== t.toLowerCase());
      list.unshift(t);
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, 10)));
    } catch (_) {}
  };
  const setTab = (key, push) => {
    const html = document.documentElement;
    html.setAttribute('data-eq-stab', key);
    document.querySelectorAll('[data-eq-shead] [data-eq-stab]').forEach((t) => t.setAttribute('aria-selected', t.dataset.eqStab === key ? 'true' : 'false'));
    if (push) {
      const u = new URL(location.href);
      if (key === 'all') u.searchParams.delete('aba'); else u.searchParams.set('aba', key);
      history.replaceState(history.state, '', u.toString());
    }
    requestAnimationFrame(() => document.querySelectorAll('[data-eq-spanel] eq-carousel').forEach((c) => c.offsetParent && c.build && c.build()));
    document.dispatchEvent(new CustomEvent('eq:search:tab', { detail: key }));
  };
  window.EQ_SEARCH_TAB = setTab;
  const boot = () => {
    const head = document.querySelector('[data-eq-shead]');
    if (head && head.dataset.term) remember(head.dataset.term);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-eq-shead] [data-eq-stab]');
    if (t) { setTab(t.dataset.eqStab, true); return; }
    const go = e.target.closest('[data-eq-goto-tab]');
    if (go) { e.preventDefault(); setTab(go.dataset.eqGotoTab, true); window.scrollTo({ top: 0, behavior: 'smooth' }); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq-search-products"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.EQ_SRES) return;
  window.EQ_SRES = 1;
  const mqD = window.matchMedia('(min-width: 990px)');

  const reveal = (root, more) => {
    const items = [...root.querySelectorAll('.eq-sres__item')];
    const per = Number(mqD.matches ? root.dataset.perD : root.dataset.perM) || 9;
    const shown = more ? (Number(root.dataset.shown) || per) + per : per;
    root.dataset.shown = shown;
    items.forEach((li, i) => (li.hidden = i >= shown));
    const btn = root.querySelector('[data-eq-sres-more]');
    if (btn) btn.hidden = shown >= items.length;
  };

  const base = (root) => {
    const p = new URLSearchParams();
    p.set('q', root.dataset.q || '');
    p.set('type', 'product');
    p.set('options[prefix]', 'last');
    return p;
  };
  const params = (root) => {
    const p = base(root);
    const seen = new Set();
    root.querySelectorAll('[data-eq-native] input').forEach((i) => {
      if ((i.type === 'checkbox' && !i.checked) || !i.name || i.value === '') return;
      const k = i.name + '=' + i.value;
      if (seen.has(k)) return;
      seen.add(k);
      p.append(i.name, i.value);
    });
    const sort = root.querySelector('[data-eq-sres-sort]');
    if (sort) p.set('sort_by', sort.value);
    return p;
  };

  const load = async (root, url) => {
    root.classList.add('is-loading');
    const u = new URL(url, location.href);
    u.searchParams.set('type', 'product');
    u.searchParams.set('section_id', root.dataset.sectionId);
    try {
      const html = await fetch(u.toString()).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-eq-sres-root]');
      const cur = root.querySelector('[data-eq-sres-root]');
      if (!fresh || !cur) return;
      const sheetOpen = root.querySelector('.eq-sheet.is-open');
      cur.innerHTML = fresh.innerHTML;
      delete root.dataset.shown;
      reveal(root);
      if (sheetOpen && window.EQ) EQ.open(root.dataset.sheet);
      if (window.EQ && EQ.favs) document.dispatchEvent(new CustomEvent('eq:fav:changed', { detail: EQ.favs.get() }));
    } catch (_) {
      location.href = url;
    } finally {
      root.classList.remove('is-loading');
    }
  };

  const boot = () => document.querySelectorAll('[data-eq-sres]').forEach((r) => reveal(r));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  mqD.addEventListener('change', () => document.querySelectorAll('[data-eq-sres]').forEach((r) => { delete r.dataset.shown; reveal(r); }));

  document.addEventListener('click', (e) => {
    const root = e.target.closest('[data-eq-sres]');
    if (!root) return;
    const tg = e.target.closest('[data-eq-sres-toggle]');
    if (tg) { const on = root.classList.toggle('is-collapsed'); tg.setAttribute('aria-expanded', on ? 'false' : 'true'); return; }
    if (e.target.closest('[data-eq-sres-more]')) { reveal(root, true); return; }
    const a = e.target.closest('[data-eq-native-link]');
    if (a) { e.preventDefault(); load(root, a.href); return; }
    if (e.target.closest('[data-eq-sres-clear]')) {
      e.preventDefault();
      const p = base(root);
      const sort = root.querySelector('[data-eq-sres-sort]');
      if (sort) p.set('sort_by', sort.value);
      load(root, location.pathname + '?' + p.toString());
    }
  });
  document.addEventListener('change', (e) => {
    const t = e.target;
    const root = t.closest && t.closest('[data-eq-sres]');
    if (!root) return;
    if (t.closest('[data-eq-native]') && t.name) {
      root.querySelectorAll('[data-eq-native] input').forEach((o) => {
        if (o === t || o.name !== t.name) return;
        if (t.type === 'checkbox' && o.value === t.value) o.checked = t.checked;
        if (t.type !== 'checkbox') o.value = t.value;
      });
    }
    if (t.closest('[data-eq-native]') || t.matches('[data-eq-sres-sort]')) {
      clearTimeout(root._t);
      root._t = setTimeout(() => load(root, location.pathname + '?' + params(root).toString()), t.type === 'number' ? 450 : 200);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
